import { jsx as g, jsxs as D, Fragment as Vt } from "react/jsx-runtime";
import je from "react";
/*!
 * Font Awesome Pro 6.7.2 by @fontawesome - https://fontawesome.com
 * License - https://fontawesome.com/license (Commercial License)
 * Copyright 2024 Fonticons, Inc.
 */
const Or = {
  prefix: "fas",
  iconName: "circle-check",
  icon: [512, 512, [61533, "check-circle"], "f058", "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM369 209L241 337c-9.4 9.4-24.6 9.4-33.9 0l-64-64c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l47 47L335 175c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9z"]
}, Tr = {
  prefix: "fas",
  iconName: "circle-info",
  icon: [512, 512, ["info-circle"], "f05a", "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM216 336l24 0 0-64-24 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l48 0c13.3 0 24 10.7 24 24l0 88 8 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-80 0c-13.3 0-24-10.7-24-24s10.7-24 24-24zm40-208a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"]
}, Pr = {
  prefix: "fas",
  iconName: "triangle-exclamation",
  icon: [512, 512, [9888, "exclamation-triangle", "warning"], "f071", "M256 32c14.2 0 27.3 7.5 34.5 19.8l216 368c7.3 12.4 7.3 27.7 .2 40.1S486.3 480 472 480L40 480c-14.3 0-27.6-7.7-34.7-20.1s-7-27.8 .2-40.1l216-368C228.7 39.5 241.8 32 256 32zm0 128c-13.3 0-24 10.7-24 24l0 112c0 13.3 10.7 24 24 24s24-10.7 24-24l0-112c0-13.3-10.7-24-24-24zm32 224a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z"]
}, kr = Pr, _r = {
  prefix: "fas",
  iconName: "circle-xmark",
  icon: [512, 512, [61532, "times-circle", "xmark-circle"], "f057", "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM175 175c9.4-9.4 24.6-9.4 33.9 0l47 47 47-47c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-47 47 47 47c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-47-47-47 47c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l47-47-47-47c-9.4-9.4-9.4-24.6 0-33.9z"]
};
/*!
 * Font Awesome Free 6.7.2 by @fontawesome - https://fontawesome.com
 * License - https://fontawesome.com/license/free (Icons: CC BY 4.0, Fonts: SIL OFL 1.1, Code: MIT License)
 * Copyright 2024 Fonticons, Inc.
 */
function Nr(e, t, n) {
  return (t = Fr(t)) in e ? Object.defineProperty(e, t, {
    value: n,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = n, e;
}
function Gt(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function f(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Gt(Object(n), !0).forEach(function(r) {
      Nr(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : Gt(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function Ir(e, t) {
  if (typeof e != "object" || !e) return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var r = n.call(e, t);
    if (typeof r != "object") return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function Fr(e) {
  var t = Ir(e, "string");
  return typeof t == "symbol" ? t : t + "";
}
const Xt = () => {
};
let It = {}, $n = {}, Un = null, Wn = {
  mark: Xt,
  measure: Xt
};
try {
  typeof window < "u" && (It = window), typeof document < "u" && ($n = document), typeof MutationObserver < "u" && (Un = MutationObserver), typeof performance < "u" && (Wn = performance);
} catch {
}
const {
  userAgent: Zt = ""
} = It.navigator || {}, re = It, $ = $n, Kt = Un, ke = Wn;
re.document;
const ee = !!$.documentElement && !!$.head && typeof $.addEventListener == "function" && typeof $.createElement == "function", Yn = ~Zt.indexOf("MSIE") || ~Zt.indexOf("Trident/");
var Rr = /fa(s|r|l|t|d|dr|dl|dt|b|k|kd|ss|sr|sl|st|sds|sdr|sdl|sdt)?[\-\ ]/, Mr = /Font ?Awesome ?([56 ]*)(Solid|Regular|Light|Thin|Duotone|Brands|Free|Pro|Sharp Duotone|Sharp|Kit)?.*/i, qn = {
  classic: {
    fa: "solid",
    fas: "solid",
    "fa-solid": "solid",
    far: "regular",
    "fa-regular": "regular",
    fal: "light",
    "fa-light": "light",
    fat: "thin",
    "fa-thin": "thin",
    fab: "brands",
    "fa-brands": "brands"
  },
  duotone: {
    fa: "solid",
    fad: "solid",
    "fa-solid": "solid",
    "fa-duotone": "solid",
    fadr: "regular",
    "fa-regular": "regular",
    fadl: "light",
    "fa-light": "light",
    fadt: "thin",
    "fa-thin": "thin"
  },
  sharp: {
    fa: "solid",
    fass: "solid",
    "fa-solid": "solid",
    fasr: "regular",
    "fa-regular": "regular",
    fasl: "light",
    "fa-light": "light",
    fast: "thin",
    "fa-thin": "thin"
  },
  "sharp-duotone": {
    fa: "solid",
    fasds: "solid",
    "fa-solid": "solid",
    fasdr: "regular",
    "fa-regular": "regular",
    fasdl: "light",
    "fa-light": "light",
    fasdt: "thin",
    "fa-thin": "thin"
  }
}, zr = {
  GROUP: "duotone-group",
  PRIMARY: "primary",
  SECONDARY: "secondary"
}, Hn = ["fa-classic", "fa-duotone", "fa-sharp", "fa-sharp-duotone"], W = "classic", De = "duotone", Lr = "sharp", jr = "sharp-duotone", Bn = [W, De, Lr, jr], Dr = {
  classic: {
    900: "fas",
    400: "far",
    normal: "far",
    300: "fal",
    100: "fat"
  },
  duotone: {
    900: "fad",
    400: "fadr",
    300: "fadl",
    100: "fadt"
  },
  sharp: {
    900: "fass",
    400: "fasr",
    300: "fasl",
    100: "fast"
  },
  "sharp-duotone": {
    900: "fasds",
    400: "fasdr",
    300: "fasdl",
    100: "fasdt"
  }
}, $r = {
  "Font Awesome 6 Free": {
    900: "fas",
    400: "far"
  },
  "Font Awesome 6 Pro": {
    900: "fas",
    400: "far",
    normal: "far",
    300: "fal",
    100: "fat"
  },
  "Font Awesome 6 Brands": {
    400: "fab",
    normal: "fab"
  },
  "Font Awesome 6 Duotone": {
    900: "fad",
    400: "fadr",
    normal: "fadr",
    300: "fadl",
    100: "fadt"
  },
  "Font Awesome 6 Sharp": {
    900: "fass",
    400: "fasr",
    normal: "fasr",
    300: "fasl",
    100: "fast"
  },
  "Font Awesome 6 Sharp Duotone": {
    900: "fasds",
    400: "fasdr",
    normal: "fasdr",
    300: "fasdl",
    100: "fasdt"
  }
}, Ur = /* @__PURE__ */ new Map([["classic", {
  defaultShortPrefixId: "fas",
  defaultStyleId: "solid",
  styleIds: ["solid", "regular", "light", "thin", "brands"],
  futureStyleIds: [],
  defaultFontWeight: 900
}], ["sharp", {
  defaultShortPrefixId: "fass",
  defaultStyleId: "solid",
  styleIds: ["solid", "regular", "light", "thin"],
  futureStyleIds: [],
  defaultFontWeight: 900
}], ["duotone", {
  defaultShortPrefixId: "fad",
  defaultStyleId: "solid",
  styleIds: ["solid", "regular", "light", "thin"],
  futureStyleIds: [],
  defaultFontWeight: 900
}], ["sharp-duotone", {
  defaultShortPrefixId: "fasds",
  defaultStyleId: "solid",
  styleIds: ["solid", "regular", "light", "thin"],
  futureStyleIds: [],
  defaultFontWeight: 900
}]]), Wr = {
  classic: {
    solid: "fas",
    regular: "far",
    light: "fal",
    thin: "fat",
    brands: "fab"
  },
  duotone: {
    solid: "fad",
    regular: "fadr",
    light: "fadl",
    thin: "fadt"
  },
  sharp: {
    solid: "fass",
    regular: "fasr",
    light: "fasl",
    thin: "fast"
  },
  "sharp-duotone": {
    solid: "fasds",
    regular: "fasdr",
    light: "fasdl",
    thin: "fasdt"
  }
}, Yr = ["fak", "fa-kit", "fakd", "fa-kit-duotone"], Jt = {
  kit: {
    fak: "kit",
    "fa-kit": "kit"
  },
  "kit-duotone": {
    fakd: "kit-duotone",
    "fa-kit-duotone": "kit-duotone"
  }
}, qr = ["kit"], Hr = {
  kit: {
    "fa-kit": "fak"
  }
}, Br = ["fak", "fakd"], Vr = {
  kit: {
    fak: "fa-kit"
  }
}, Qt = {
  kit: {
    kit: "fak"
  },
  "kit-duotone": {
    "kit-duotone": "fakd"
  }
}, _e = {
  GROUP: "duotone-group",
  SWAP_OPACITY: "swap-opacity",
  PRIMARY: "primary",
  SECONDARY: "secondary"
}, Gr = ["fa-classic", "fa-duotone", "fa-sharp", "fa-sharp-duotone"], Xr = ["fak", "fa-kit", "fakd", "fa-kit-duotone"], Zr = {
  "Font Awesome Kit": {
    400: "fak",
    normal: "fak"
  },
  "Font Awesome Kit Duotone": {
    400: "fakd",
    normal: "fakd"
  }
}, Kr = {
  classic: {
    "fa-brands": "fab",
    "fa-duotone": "fad",
    "fa-light": "fal",
    "fa-regular": "far",
    "fa-solid": "fas",
    "fa-thin": "fat"
  },
  duotone: {
    "fa-regular": "fadr",
    "fa-light": "fadl",
    "fa-thin": "fadt"
  },
  sharp: {
    "fa-solid": "fass",
    "fa-regular": "fasr",
    "fa-light": "fasl",
    "fa-thin": "fast"
  },
  "sharp-duotone": {
    "fa-solid": "fasds",
    "fa-regular": "fasdr",
    "fa-light": "fasdl",
    "fa-thin": "fasdt"
  }
}, Jr = {
  classic: ["fas", "far", "fal", "fat", "fad"],
  duotone: ["fadr", "fadl", "fadt"],
  sharp: ["fass", "fasr", "fasl", "fast"],
  "sharp-duotone": ["fasds", "fasdr", "fasdl", "fasdt"]
}, mt = {
  classic: {
    fab: "fa-brands",
    fad: "fa-duotone",
    fal: "fa-light",
    far: "fa-regular",
    fas: "fa-solid",
    fat: "fa-thin"
  },
  duotone: {
    fadr: "fa-regular",
    fadl: "fa-light",
    fadt: "fa-thin"
  },
  sharp: {
    fass: "fa-solid",
    fasr: "fa-regular",
    fasl: "fa-light",
    fast: "fa-thin"
  },
  "sharp-duotone": {
    fasds: "fa-solid",
    fasdr: "fa-regular",
    fasdl: "fa-light",
    fasdt: "fa-thin"
  }
}, Qr = ["fa-solid", "fa-regular", "fa-light", "fa-thin", "fa-duotone", "fa-brands"], pt = ["fa", "fas", "far", "fal", "fat", "fad", "fadr", "fadl", "fadt", "fab", "fass", "fasr", "fasl", "fast", "fasds", "fasdr", "fasdl", "fasdt", ...Gr, ...Qr], ea = ["solid", "regular", "light", "thin", "duotone", "brands"], Vn = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10], ta = Vn.concat([11, 12, 13, 14, 15, 16, 17, 18, 19, 20]), na = [...Object.keys(Jr), ...ea, "2xs", "xs", "sm", "lg", "xl", "2xl", "beat", "border", "fade", "beat-fade", "bounce", "flip-both", "flip-horizontal", "flip-vertical", "flip", "fw", "inverse", "layers-counter", "layers-text", "layers", "li", "pull-left", "pull-right", "pulse", "rotate-180", "rotate-270", "rotate-90", "rotate-by", "shake", "spin-pulse", "spin-reverse", "spin", "stack-1x", "stack-2x", "stack", "ul", _e.GROUP, _e.SWAP_OPACITY, _e.PRIMARY, _e.SECONDARY].concat(Vn.map((e) => "".concat(e, "x"))).concat(ta.map((e) => "w-".concat(e))), ra = {
  "Font Awesome 5 Free": {
    900: "fas",
    400: "far"
  },
  "Font Awesome 5 Pro": {
    900: "fas",
    400: "far",
    normal: "far",
    300: "fal"
  },
  "Font Awesome 5 Brands": {
    400: "fab",
    normal: "fab"
  },
  "Font Awesome 5 Duotone": {
    900: "fad"
  }
};
const J = "___FONT_AWESOME___", gt = 16, Gn = "fa", Xn = "svg-inline--fa", fe = "data-fa-i2svg", ht = "data-fa-pseudo-element", aa = "data-fa-pseudo-element-pending", Ft = "data-prefix", Rt = "data-icon", en = "fontawesome-i2svg", ia = "async", oa = ["HTML", "HEAD", "STYLE", "SCRIPT"], Zn = (() => {
  try {
    return process.env.NODE_ENV === "production";
  } catch {
    return !1;
  }
})();
function Ce(e) {
  return new Proxy(e, {
    get(t, n) {
      return n in t ? t[n] : t[W];
    }
  });
}
const Kn = f({}, qn);
Kn[W] = f(f(f(f({}, {
  "fa-duotone": "duotone"
}), qn[W]), Jt.kit), Jt["kit-duotone"]);
const sa = Ce(Kn), bt = f({}, Wr);
bt[W] = f(f(f(f({}, {
  duotone: "fad"
}), bt[W]), Qt.kit), Qt["kit-duotone"]);
const tn = Ce(bt), yt = f({}, mt);
yt[W] = f(f({}, yt[W]), Vr.kit);
const Mt = Ce(yt), vt = f({}, Kr);
vt[W] = f(f({}, vt[W]), Hr.kit);
Ce(vt);
const la = Rr, Jn = "fa-layers-text", ca = Mr, fa = f({}, Dr);
Ce(fa);
const ua = ["class", "data-prefix", "data-icon", "data-fa-transform", "data-fa-mask"], Ze = zr, da = [...qr, ...na], xe = re.FontAwesomeConfig || {};
function ma(e) {
  var t = $.querySelector("script[" + e + "]");
  if (t)
    return t.getAttribute(e);
}
function pa(e) {
  return e === "" ? !0 : e === "false" ? !1 : e === "true" ? !0 : e;
}
$ && typeof $.querySelector == "function" && [["data-family-prefix", "familyPrefix"], ["data-css-prefix", "cssPrefix"], ["data-family-default", "familyDefault"], ["data-style-default", "styleDefault"], ["data-replacement-class", "replacementClass"], ["data-auto-replace-svg", "autoReplaceSvg"], ["data-auto-add-css", "autoAddCss"], ["data-auto-a11y", "autoA11y"], ["data-search-pseudo-elements", "searchPseudoElements"], ["data-observe-mutations", "observeMutations"], ["data-mutate-approach", "mutateApproach"], ["data-keep-original-source", "keepOriginalSource"], ["data-measure-performance", "measurePerformance"], ["data-show-missing-icons", "showMissingIcons"]].forEach((t) => {
  let [n, r] = t;
  const a = pa(ma(n));
  a != null && (xe[r] = a);
});
const Qn = {
  styleDefault: "solid",
  familyDefault: W,
  cssPrefix: Gn,
  replacementClass: Xn,
  autoReplaceSvg: !0,
  autoAddCss: !0,
  autoA11y: !0,
  searchPseudoElements: !1,
  observeMutations: !0,
  mutateApproach: "async",
  keepOriginalSource: !0,
  measurePerformance: !1,
  showMissingIcons: !0
};
xe.familyPrefix && (xe.cssPrefix = xe.familyPrefix);
const he = f(f({}, Qn), xe);
he.autoReplaceSvg || (he.observeMutations = !1);
const v = {};
Object.keys(Qn).forEach((e) => {
  Object.defineProperty(v, e, {
    enumerable: !0,
    set: function(t) {
      he[e] = t, we.forEach((n) => n(v));
    },
    get: function() {
      return he[e];
    }
  });
});
Object.defineProperty(v, "familyPrefix", {
  enumerable: !0,
  set: function(e) {
    he.cssPrefix = e, we.forEach((t) => t(v));
  },
  get: function() {
    return he.cssPrefix;
  }
});
re.FontAwesomeConfig = v;
const we = [];
function ga(e) {
  return we.push(e), () => {
    we.splice(we.indexOf(e), 1);
  };
}
const te = gt, X = {
  size: 16,
  x: 0,
  y: 0,
  rotate: 0,
  flipX: !1,
  flipY: !1
};
function ha(e) {
  if (!e || !ee)
    return;
  const t = $.createElement("style");
  t.setAttribute("type", "text/css"), t.innerHTML = e;
  const n = $.head.childNodes;
  let r = null;
  for (let a = n.length - 1; a > -1; a--) {
    const i = n[a], o = (i.tagName || "").toUpperCase();
    ["STYLE", "LINK"].indexOf(o) > -1 && (r = i);
  }
  return $.head.insertBefore(t, r), e;
}
const ba = "0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ";
function Ae() {
  let e = 12, t = "";
  for (; e-- > 0; )
    t += ba[Math.random() * 62 | 0];
  return t;
}
function be(e) {
  const t = [];
  for (let n = (e || []).length >>> 0; n--; )
    t[n] = e[n];
  return t;
}
function zt(e) {
  return e.classList ? be(e.classList) : (e.getAttribute("class") || "").split(" ").filter((t) => t);
}
function er(e) {
  return "".concat(e).replace(/&/g, "&amp;").replace(/"/g, "&quot;").replace(/'/g, "&#39;").replace(/</g, "&lt;").replace(/>/g, "&gt;");
}
function ya(e) {
  return Object.keys(e || {}).reduce((t, n) => t + "".concat(n, '="').concat(er(e[n]), '" '), "").trim();
}
function $e(e) {
  return Object.keys(e || {}).reduce((t, n) => t + "".concat(n, ": ").concat(e[n].trim(), ";"), "");
}
function Lt(e) {
  return e.size !== X.size || e.x !== X.x || e.y !== X.y || e.rotate !== X.rotate || e.flipX || e.flipY;
}
function va(e) {
  let {
    transform: t,
    containerWidth: n,
    iconWidth: r
  } = e;
  const a = {
    transform: "translate(".concat(n / 2, " 256)")
  }, i = "translate(".concat(t.x * 32, ", ").concat(t.y * 32, ") "), o = "scale(".concat(t.size / 16 * (t.flipX ? -1 : 1), ", ").concat(t.size / 16 * (t.flipY ? -1 : 1), ") "), s = "rotate(".concat(t.rotate, " 0 0)"), d = {
    transform: "".concat(i, " ").concat(o, " ").concat(s)
  }, c = {
    transform: "translate(".concat(r / 2 * -1, " -256)")
  };
  return {
    outer: a,
    inner: d,
    path: c
  };
}
function xa(e) {
  let {
    transform: t,
    width: n = gt,
    height: r = gt,
    startCentered: a = !1
  } = e, i = "";
  return a && Yn ? i += "translate(".concat(t.x / te - n / 2, "em, ").concat(t.y / te - r / 2, "em) ") : a ? i += "translate(calc(-50% + ".concat(t.x / te, "em), calc(-50% + ").concat(t.y / te, "em)) ") : i += "translate(".concat(t.x / te, "em, ").concat(t.y / te, "em) "), i += "scale(".concat(t.size / te * (t.flipX ? -1 : 1), ", ").concat(t.size / te * (t.flipY ? -1 : 1), ") "), i += "rotate(".concat(t.rotate, "deg) "), i;
}
var wa = `:root, :host {
  --fa-font-solid: normal 900 1em/1 "Font Awesome 6 Free";
  --fa-font-regular: normal 400 1em/1 "Font Awesome 6 Free";
  --fa-font-light: normal 300 1em/1 "Font Awesome 6 Pro";
  --fa-font-thin: normal 100 1em/1 "Font Awesome 6 Pro";
  --fa-font-duotone: normal 900 1em/1 "Font Awesome 6 Duotone";
  --fa-font-duotone-regular: normal 400 1em/1 "Font Awesome 6 Duotone";
  --fa-font-duotone-light: normal 300 1em/1 "Font Awesome 6 Duotone";
  --fa-font-duotone-thin: normal 100 1em/1 "Font Awesome 6 Duotone";
  --fa-font-brands: normal 400 1em/1 "Font Awesome 6 Brands";
  --fa-font-sharp-solid: normal 900 1em/1 "Font Awesome 6 Sharp";
  --fa-font-sharp-regular: normal 400 1em/1 "Font Awesome 6 Sharp";
  --fa-font-sharp-light: normal 300 1em/1 "Font Awesome 6 Sharp";
  --fa-font-sharp-thin: normal 100 1em/1 "Font Awesome 6 Sharp";
  --fa-font-sharp-duotone-solid: normal 900 1em/1 "Font Awesome 6 Sharp Duotone";
  --fa-font-sharp-duotone-regular: normal 400 1em/1 "Font Awesome 6 Sharp Duotone";
  --fa-font-sharp-duotone-light: normal 300 1em/1 "Font Awesome 6 Sharp Duotone";
  --fa-font-sharp-duotone-thin: normal 100 1em/1 "Font Awesome 6 Sharp Duotone";
}

svg:not(:root).svg-inline--fa, svg:not(:host).svg-inline--fa {
  overflow: visible;
  box-sizing: content-box;
}

.svg-inline--fa {
  display: var(--fa-display, inline-block);
  height: 1em;
  overflow: visible;
  vertical-align: -0.125em;
}
.svg-inline--fa.fa-2xs {
  vertical-align: 0.1em;
}
.svg-inline--fa.fa-xs {
  vertical-align: 0em;
}
.svg-inline--fa.fa-sm {
  vertical-align: -0.0714285705em;
}
.svg-inline--fa.fa-lg {
  vertical-align: -0.2em;
}
.svg-inline--fa.fa-xl {
  vertical-align: -0.25em;
}
.svg-inline--fa.fa-2xl {
  vertical-align: -0.3125em;
}
.svg-inline--fa.fa-pull-left {
  margin-right: var(--fa-pull-margin, 0.3em);
  width: auto;
}
.svg-inline--fa.fa-pull-right {
  margin-left: var(--fa-pull-margin, 0.3em);
  width: auto;
}
.svg-inline--fa.fa-li {
  width: var(--fa-li-width, 2em);
  top: 0.25em;
}
.svg-inline--fa.fa-fw {
  width: var(--fa-fw-width, 1.25em);
}

.fa-layers svg.svg-inline--fa {
  bottom: 0;
  left: 0;
  margin: auto;
  position: absolute;
  right: 0;
  top: 0;
}

.fa-layers-counter, .fa-layers-text {
  display: inline-block;
  position: absolute;
  text-align: center;
}

.fa-layers {
  display: inline-block;
  height: 1em;
  position: relative;
  text-align: center;
  vertical-align: -0.125em;
  width: 1em;
}
.fa-layers svg.svg-inline--fa {
  transform-origin: center center;
}

.fa-layers-text {
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  transform-origin: center center;
}

.fa-layers-counter {
  background-color: var(--fa-counter-background-color, #ff253a);
  border-radius: var(--fa-counter-border-radius, 1em);
  box-sizing: border-box;
  color: var(--fa-inverse, #fff);
  line-height: var(--fa-counter-line-height, 1);
  max-width: var(--fa-counter-max-width, 5em);
  min-width: var(--fa-counter-min-width, 1.5em);
  overflow: hidden;
  padding: var(--fa-counter-padding, 0.25em 0.5em);
  right: var(--fa-right, 0);
  text-overflow: ellipsis;
  top: var(--fa-top, 0);
  transform: scale(var(--fa-counter-scale, 0.25));
  transform-origin: top right;
}

.fa-layers-bottom-right {
  bottom: var(--fa-bottom, 0);
  right: var(--fa-right, 0);
  top: auto;
  transform: scale(var(--fa-layers-scale, 0.25));
  transform-origin: bottom right;
}

.fa-layers-bottom-left {
  bottom: var(--fa-bottom, 0);
  left: var(--fa-left, 0);
  right: auto;
  top: auto;
  transform: scale(var(--fa-layers-scale, 0.25));
  transform-origin: bottom left;
}

.fa-layers-top-right {
  top: var(--fa-top, 0);
  right: var(--fa-right, 0);
  transform: scale(var(--fa-layers-scale, 0.25));
  transform-origin: top right;
}

.fa-layers-top-left {
  left: var(--fa-left, 0);
  right: auto;
  top: var(--fa-top, 0);
  transform: scale(var(--fa-layers-scale, 0.25));
  transform-origin: top left;
}

.fa-1x {
  font-size: 1em;
}

.fa-2x {
  font-size: 2em;
}

.fa-3x {
  font-size: 3em;
}

.fa-4x {
  font-size: 4em;
}

.fa-5x {
  font-size: 5em;
}

.fa-6x {
  font-size: 6em;
}

.fa-7x {
  font-size: 7em;
}

.fa-8x {
  font-size: 8em;
}

.fa-9x {
  font-size: 9em;
}

.fa-10x {
  font-size: 10em;
}

.fa-2xs {
  font-size: 0.625em;
  line-height: 0.1em;
  vertical-align: 0.225em;
}

.fa-xs {
  font-size: 0.75em;
  line-height: 0.0833333337em;
  vertical-align: 0.125em;
}

.fa-sm {
  font-size: 0.875em;
  line-height: 0.0714285718em;
  vertical-align: 0.0535714295em;
}

.fa-lg {
  font-size: 1.25em;
  line-height: 0.05em;
  vertical-align: -0.075em;
}

.fa-xl {
  font-size: 1.5em;
  line-height: 0.0416666682em;
  vertical-align: -0.125em;
}

.fa-2xl {
  font-size: 2em;
  line-height: 0.03125em;
  vertical-align: -0.1875em;
}

.fa-fw {
  text-align: center;
  width: 1.25em;
}

.fa-ul {
  list-style-type: none;
  margin-left: var(--fa-li-margin, 2.5em);
  padding-left: 0;
}
.fa-ul > li {
  position: relative;
}

.fa-li {
  left: calc(-1 * var(--fa-li-width, 2em));
  position: absolute;
  text-align: center;
  width: var(--fa-li-width, 2em);
  line-height: inherit;
}

.fa-border {
  border-color: var(--fa-border-color, #eee);
  border-radius: var(--fa-border-radius, 0.1em);
  border-style: var(--fa-border-style, solid);
  border-width: var(--fa-border-width, 0.08em);
  padding: var(--fa-border-padding, 0.2em 0.25em 0.15em);
}

.fa-pull-left {
  float: left;
  margin-right: var(--fa-pull-margin, 0.3em);
}

.fa-pull-right {
  float: right;
  margin-left: var(--fa-pull-margin, 0.3em);
}

.fa-beat {
  animation-name: fa-beat;
  animation-delay: var(--fa-animation-delay, 0s);
  animation-direction: var(--fa-animation-direction, normal);
  animation-duration: var(--fa-animation-duration, 1s);
  animation-iteration-count: var(--fa-animation-iteration-count, infinite);
  animation-timing-function: var(--fa-animation-timing, ease-in-out);
}

.fa-bounce {
  animation-name: fa-bounce;
  animation-delay: var(--fa-animation-delay, 0s);
  animation-direction: var(--fa-animation-direction, normal);
  animation-duration: var(--fa-animation-duration, 1s);
  animation-iteration-count: var(--fa-animation-iteration-count, infinite);
  animation-timing-function: var(--fa-animation-timing, cubic-bezier(0.28, 0.84, 0.42, 1));
}

.fa-fade {
  animation-name: fa-fade;
  animation-delay: var(--fa-animation-delay, 0s);
  animation-direction: var(--fa-animation-direction, normal);
  animation-duration: var(--fa-animation-duration, 1s);
  animation-iteration-count: var(--fa-animation-iteration-count, infinite);
  animation-timing-function: var(--fa-animation-timing, cubic-bezier(0.4, 0, 0.6, 1));
}

.fa-beat-fade {
  animation-name: fa-beat-fade;
  animation-delay: var(--fa-animation-delay, 0s);
  animation-direction: var(--fa-animation-direction, normal);
  animation-duration: var(--fa-animation-duration, 1s);
  animation-iteration-count: var(--fa-animation-iteration-count, infinite);
  animation-timing-function: var(--fa-animation-timing, cubic-bezier(0.4, 0, 0.6, 1));
}

.fa-flip {
  animation-name: fa-flip;
  animation-delay: var(--fa-animation-delay, 0s);
  animation-direction: var(--fa-animation-direction, normal);
  animation-duration: var(--fa-animation-duration, 1s);
  animation-iteration-count: var(--fa-animation-iteration-count, infinite);
  animation-timing-function: var(--fa-animation-timing, ease-in-out);
}

.fa-shake {
  animation-name: fa-shake;
  animation-delay: var(--fa-animation-delay, 0s);
  animation-direction: var(--fa-animation-direction, normal);
  animation-duration: var(--fa-animation-duration, 1s);
  animation-iteration-count: var(--fa-animation-iteration-count, infinite);
  animation-timing-function: var(--fa-animation-timing, linear);
}

.fa-spin {
  animation-name: fa-spin;
  animation-delay: var(--fa-animation-delay, 0s);
  animation-direction: var(--fa-animation-direction, normal);
  animation-duration: var(--fa-animation-duration, 2s);
  animation-iteration-count: var(--fa-animation-iteration-count, infinite);
  animation-timing-function: var(--fa-animation-timing, linear);
}

.fa-spin-reverse {
  --fa-animation-direction: reverse;
}

.fa-pulse,
.fa-spin-pulse {
  animation-name: fa-spin;
  animation-direction: var(--fa-animation-direction, normal);
  animation-duration: var(--fa-animation-duration, 1s);
  animation-iteration-count: var(--fa-animation-iteration-count, infinite);
  animation-timing-function: var(--fa-animation-timing, steps(8));
}

@media (prefers-reduced-motion: reduce) {
  .fa-beat,
.fa-bounce,
.fa-fade,
.fa-beat-fade,
.fa-flip,
.fa-pulse,
.fa-shake,
.fa-spin,
.fa-spin-pulse {
    animation-delay: -1ms;
    animation-duration: 1ms;
    animation-iteration-count: 1;
    transition-delay: 0s;
    transition-duration: 0s;
  }
}
@keyframes fa-beat {
  0%, 90% {
    transform: scale(1);
  }
  45% {
    transform: scale(var(--fa-beat-scale, 1.25));
  }
}
@keyframes fa-bounce {
  0% {
    transform: scale(1, 1) translateY(0);
  }
  10% {
    transform: scale(var(--fa-bounce-start-scale-x, 1.1), var(--fa-bounce-start-scale-y, 0.9)) translateY(0);
  }
  30% {
    transform: scale(var(--fa-bounce-jump-scale-x, 0.9), var(--fa-bounce-jump-scale-y, 1.1)) translateY(var(--fa-bounce-height, -0.5em));
  }
  50% {
    transform: scale(var(--fa-bounce-land-scale-x, 1.05), var(--fa-bounce-land-scale-y, 0.95)) translateY(0);
  }
  57% {
    transform: scale(1, 1) translateY(var(--fa-bounce-rebound, -0.125em));
  }
  64% {
    transform: scale(1, 1) translateY(0);
  }
  100% {
    transform: scale(1, 1) translateY(0);
  }
}
@keyframes fa-fade {
  50% {
    opacity: var(--fa-fade-opacity, 0.4);
  }
}
@keyframes fa-beat-fade {
  0%, 100% {
    opacity: var(--fa-beat-fade-opacity, 0.4);
    transform: scale(1);
  }
  50% {
    opacity: 1;
    transform: scale(var(--fa-beat-fade-scale, 1.125));
  }
}
@keyframes fa-flip {
  50% {
    transform: rotate3d(var(--fa-flip-x, 0), var(--fa-flip-y, 1), var(--fa-flip-z, 0), var(--fa-flip-angle, -180deg));
  }
}
@keyframes fa-shake {
  0% {
    transform: rotate(-15deg);
  }
  4% {
    transform: rotate(15deg);
  }
  8%, 24% {
    transform: rotate(-18deg);
  }
  12%, 28% {
    transform: rotate(18deg);
  }
  16% {
    transform: rotate(-22deg);
  }
  20% {
    transform: rotate(22deg);
  }
  32% {
    transform: rotate(-12deg);
  }
  36% {
    transform: rotate(12deg);
  }
  40%, 100% {
    transform: rotate(0deg);
  }
}
@keyframes fa-spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
.fa-rotate-90 {
  transform: rotate(90deg);
}

.fa-rotate-180 {
  transform: rotate(180deg);
}

.fa-rotate-270 {
  transform: rotate(270deg);
}

.fa-flip-horizontal {
  transform: scale(-1, 1);
}

.fa-flip-vertical {
  transform: scale(1, -1);
}

.fa-flip-both,
.fa-flip-horizontal.fa-flip-vertical {
  transform: scale(-1, -1);
}

.fa-rotate-by {
  transform: rotate(var(--fa-rotate-angle, 0));
}

.fa-stack {
  display: inline-block;
  vertical-align: middle;
  height: 2em;
  position: relative;
  width: 2.5em;
}

.fa-stack-1x,
.fa-stack-2x {
  bottom: 0;
  left: 0;
  margin: auto;
  position: absolute;
  right: 0;
  top: 0;
  z-index: var(--fa-stack-z-index, auto);
}

.svg-inline--fa.fa-stack-1x {
  height: 1em;
  width: 1.25em;
}
.svg-inline--fa.fa-stack-2x {
  height: 2em;
  width: 2.5em;
}

.fa-inverse {
  color: var(--fa-inverse, #fff);
}

.sr-only,
.fa-sr-only {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border-width: 0;
}

.sr-only-focusable:not(:focus),
.fa-sr-only-focusable:not(:focus) {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border-width: 0;
}

.svg-inline--fa .fa-primary {
  fill: var(--fa-primary-color, currentColor);
  opacity: var(--fa-primary-opacity, 1);
}

.svg-inline--fa .fa-secondary {
  fill: var(--fa-secondary-color, currentColor);
  opacity: var(--fa-secondary-opacity, 0.4);
}

.svg-inline--fa.fa-swap-opacity .fa-primary {
  opacity: var(--fa-secondary-opacity, 0.4);
}

.svg-inline--fa.fa-swap-opacity .fa-secondary {
  opacity: var(--fa-primary-opacity, 1);
}

.svg-inline--fa mask .fa-primary,
.svg-inline--fa mask .fa-secondary {
  fill: black;
}`;
function tr() {
  const e = Gn, t = Xn, n = v.cssPrefix, r = v.replacementClass;
  let a = wa;
  if (n !== e || r !== t) {
    const i = new RegExp("\\.".concat(e, "\\-"), "g"), o = new RegExp("\\--".concat(e, "\\-"), "g"), s = new RegExp("\\.".concat(t), "g");
    a = a.replace(i, ".".concat(n, "-")).replace(o, "--".concat(n, "-")).replace(s, ".".concat(r));
  }
  return a;
}
let nn = !1;
function Ke() {
  v.autoAddCss && !nn && (ha(tr()), nn = !0);
}
var Aa = {
  mixout() {
    return {
      dom: {
        css: tr,
        insertCss: Ke
      }
    };
  },
  hooks() {
    return {
      beforeDOMElementCreation() {
        Ke();
      },
      beforeI2svg() {
        Ke();
      }
    };
  }
};
const Q = re || {};
Q[J] || (Q[J] = {});
Q[J].styles || (Q[J].styles = {});
Q[J].hooks || (Q[J].hooks = {});
Q[J].shims || (Q[J].shims = []);
var Z = Q[J];
const nr = [], rr = function() {
  $.removeEventListener("DOMContentLoaded", rr), Me = 1, nr.map((e) => e());
};
let Me = !1;
ee && (Me = ($.documentElement.doScroll ? /^loaded|^c/ : /^loaded|^i|^c/).test($.readyState), Me || $.addEventListener("DOMContentLoaded", rr));
function Ea(e) {
  ee && (Me ? setTimeout(e, 0) : nr.push(e));
}
function Se(e) {
  const {
    tag: t,
    attributes: n = {},
    children: r = []
  } = e;
  return typeof e == "string" ? er(e) : "<".concat(t, " ").concat(ya(n), ">").concat(r.map(Se).join(""), "</").concat(t, ">");
}
function rn(e, t, n) {
  if (e && e[t] && e[t][n])
    return {
      prefix: t,
      iconName: n,
      icon: e[t][n]
    };
}
var Je = function(t, n, r, a) {
  var i = Object.keys(t), o = i.length, s = n, d, c, u;
  for (r === void 0 ? (d = 1, u = t[i[0]]) : (d = 0, u = r); d < o; d++)
    c = i[d], u = s(u, t[c], c, t);
  return u;
};
function Ca(e) {
  const t = [];
  let n = 0;
  const r = e.length;
  for (; n < r; ) {
    const a = e.charCodeAt(n++);
    if (a >= 55296 && a <= 56319 && n < r) {
      const i = e.charCodeAt(n++);
      (i & 64512) == 56320 ? t.push(((a & 1023) << 10) + (i & 1023) + 65536) : (t.push(a), n--);
    } else
      t.push(a);
  }
  return t;
}
function xt(e) {
  const t = Ca(e);
  return t.length === 1 ? t[0].toString(16) : null;
}
function Sa(e, t) {
  const n = e.length;
  let r = e.charCodeAt(t), a;
  return r >= 55296 && r <= 56319 && n > t + 1 && (a = e.charCodeAt(t + 1), a >= 56320 && a <= 57343) ? (r - 55296) * 1024 + a - 56320 + 65536 : r;
}
function an(e) {
  return Object.keys(e).reduce((t, n) => {
    const r = e[n];
    return !!r.icon ? t[r.iconName] = r.icon : t[n] = r, t;
  }, {});
}
function wt(e, t) {
  let n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  const {
    skipHooks: r = !1
  } = n, a = an(t);
  typeof Z.hooks.addPack == "function" && !r ? Z.hooks.addPack(e, an(t)) : Z.styles[e] = f(f({}, Z.styles[e] || {}), a), e === "fas" && wt("fa", t);
}
const {
  styles: Ee,
  shims: Oa
} = Z, ar = Object.keys(Mt), Ta = ar.reduce((e, t) => (e[t] = Object.keys(Mt[t]), e), {});
let jt = null, ir = {}, or = {}, sr = {}, lr = {}, cr = {};
function Pa(e) {
  return ~da.indexOf(e);
}
function ka(e, t) {
  const n = t.split("-"), r = n[0], a = n.slice(1).join("-");
  return r === e && a !== "" && !Pa(a) ? a : null;
}
const fr = () => {
  const e = (r) => Je(Ee, (a, i, o) => (a[o] = Je(i, r, {}), a), {});
  ir = e((r, a, i) => (a[3] && (r[a[3]] = i), a[2] && a[2].filter((s) => typeof s == "number").forEach((s) => {
    r[s.toString(16)] = i;
  }), r)), or = e((r, a, i) => (r[i] = i, a[2] && a[2].filter((s) => typeof s == "string").forEach((s) => {
    r[s] = i;
  }), r)), cr = e((r, a, i) => {
    const o = a[2];
    return r[i] = i, o.forEach((s) => {
      r[s] = i;
    }), r;
  });
  const t = "far" in Ee || v.autoFetchSvg, n = Je(Oa, (r, a) => {
    const i = a[0];
    let o = a[1];
    const s = a[2];
    return o === "far" && !t && (o = "fas"), typeof i == "string" && (r.names[i] = {
      prefix: o,
      iconName: s
    }), typeof i == "number" && (r.unicodes[i.toString(16)] = {
      prefix: o,
      iconName: s
    }), r;
  }, {
    names: {},
    unicodes: {}
  });
  sr = n.names, lr = n.unicodes, jt = Ue(v.styleDefault, {
    family: v.familyDefault
  });
};
ga((e) => {
  jt = Ue(e.styleDefault, {
    family: v.familyDefault
  });
});
fr();
function Dt(e, t) {
  return (ir[e] || {})[t];
}
function _a(e, t) {
  return (or[e] || {})[t];
}
function ce(e, t) {
  return (cr[e] || {})[t];
}
function ur(e) {
  return sr[e] || {
    prefix: null,
    iconName: null
  };
}
function Na(e) {
  const t = lr[e], n = Dt("fas", e);
  return t || (n ? {
    prefix: "fas",
    iconName: n
  } : null) || {
    prefix: null,
    iconName: null
  };
}
function ae() {
  return jt;
}
const dr = () => ({
  prefix: null,
  iconName: null,
  rest: []
});
function Ia(e) {
  let t = W;
  const n = ar.reduce((r, a) => (r[a] = "".concat(v.cssPrefix, "-").concat(a), r), {});
  return Bn.forEach((r) => {
    (e.includes(n[r]) || e.some((a) => Ta[r].includes(a))) && (t = r);
  }), t;
}
function Ue(e) {
  let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
  const {
    family: n = W
  } = t, r = sa[n][e];
  if (n === De && !e)
    return "fad";
  const a = tn[n][e] || tn[n][r], i = e in Z.styles ? e : null;
  return a || i || null;
}
function Fa(e) {
  let t = [], n = null;
  return e.forEach((r) => {
    const a = ka(v.cssPrefix, r);
    a ? n = a : r && t.push(r);
  }), {
    iconName: n,
    rest: t
  };
}
function on(e) {
  return e.sort().filter((t, n, r) => r.indexOf(t) === n);
}
function We(e) {
  let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
  const {
    skipLookups: n = !1
  } = t;
  let r = null;
  const a = pt.concat(Xr), i = on(e.filter((l) => a.includes(l))), o = on(e.filter((l) => !pt.includes(l))), s = i.filter((l) => (r = l, !Hn.includes(l))), [d = null] = s, c = Ia(i), u = f(f({}, Fa(o)), {}, {
    prefix: Ue(d, {
      family: c
    })
  });
  return f(f(f({}, u), La({
    values: e,
    family: c,
    styles: Ee,
    config: v,
    canonical: u,
    givenPrefix: r
  })), Ra(n, r, u));
}
function Ra(e, t, n) {
  let {
    prefix: r,
    iconName: a
  } = n;
  if (e || !r || !a)
    return {
      prefix: r,
      iconName: a
    };
  const i = t === "fa" ? ur(a) : {}, o = ce(r, a);
  return a = i.iconName || o || a, r = i.prefix || r, r === "far" && !Ee.far && Ee.fas && !v.autoFetchSvg && (r = "fas"), {
    prefix: r,
    iconName: a
  };
}
const Ma = Bn.filter((e) => e !== W || e !== De), za = Object.keys(mt).filter((e) => e !== W).map((e) => Object.keys(mt[e])).flat();
function La(e) {
  const {
    values: t,
    family: n,
    canonical: r,
    givenPrefix: a = "",
    styles: i = {},
    config: o = {}
  } = e, s = n === De, d = t.includes("fa-duotone") || t.includes("fad"), c = o.familyDefault === "duotone", u = r.prefix === "fad" || r.prefix === "fa-duotone";
  if (!s && (d || c || u) && (r.prefix = "fad"), (t.includes("fa-brands") || t.includes("fab")) && (r.prefix = "fab"), !r.prefix && Ma.includes(n) && (Object.keys(i).find((b) => za.includes(b)) || o.autoFetchSvg)) {
    const b = Ur.get(n).defaultShortPrefixId;
    r.prefix = b, r.iconName = ce(r.prefix, r.iconName) || r.iconName;
  }
  return (r.prefix === "fa" || a === "fa") && (r.prefix = ae() || "fas"), r;
}
class ja {
  constructor() {
    this.definitions = {};
  }
  add() {
    for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++)
      n[r] = arguments[r];
    const a = n.reduce(this._pullDefinitions, {});
    Object.keys(a).forEach((i) => {
      this.definitions[i] = f(f({}, this.definitions[i] || {}), a[i]), wt(i, a[i]);
      const o = Mt[W][i];
      o && wt(o, a[i]), fr();
    });
  }
  reset() {
    this.definitions = {};
  }
  _pullDefinitions(t, n) {
    const r = n.prefix && n.iconName && n.icon ? {
      0: n
    } : n;
    return Object.keys(r).map((a) => {
      const {
        prefix: i,
        iconName: o,
        icon: s
      } = r[a], d = s[2];
      t[i] || (t[i] = {}), d.length > 0 && d.forEach((c) => {
        typeof c == "string" && (t[i][c] = s);
      }), t[i][o] = s;
    }), t;
  }
}
let sn = [], me = {};
const ge = {}, Da = Object.keys(ge);
function $a(e, t) {
  let {
    mixoutsTo: n
  } = t;
  return sn = e, me = {}, Object.keys(ge).forEach((r) => {
    Da.indexOf(r) === -1 && delete ge[r];
  }), sn.forEach((r) => {
    const a = r.mixout ? r.mixout() : {};
    if (Object.keys(a).forEach((i) => {
      typeof a[i] == "function" && (n[i] = a[i]), typeof a[i] == "object" && Object.keys(a[i]).forEach((o) => {
        n[i] || (n[i] = {}), n[i][o] = a[i][o];
      });
    }), r.hooks) {
      const i = r.hooks();
      Object.keys(i).forEach((o) => {
        me[o] || (me[o] = []), me[o].push(i[o]);
      });
    }
    r.provides && r.provides(ge);
  }), n;
}
function At(e, t) {
  for (var n = arguments.length, r = new Array(n > 2 ? n - 2 : 0), a = 2; a < n; a++)
    r[a - 2] = arguments[a];
  return (me[e] || []).forEach((o) => {
    t = o.apply(null, [t, ...r]);
  }), t;
}
function ue(e) {
  for (var t = arguments.length, n = new Array(t > 1 ? t - 1 : 0), r = 1; r < t; r++)
    n[r - 1] = arguments[r];
  (me[e] || []).forEach((i) => {
    i.apply(null, n);
  });
}
function ie() {
  const e = arguments[0], t = Array.prototype.slice.call(arguments, 1);
  return ge[e] ? ge[e].apply(null, t) : void 0;
}
function Et(e) {
  e.prefix === "fa" && (e.prefix = "fas");
  let {
    iconName: t
  } = e;
  const n = e.prefix || ae();
  if (t)
    return t = ce(n, t) || t, rn(mr.definitions, n, t) || rn(Z.styles, n, t);
}
const mr = new ja(), Ua = () => {
  v.autoReplaceSvg = !1, v.observeMutations = !1, ue("noAuto");
}, Wa = {
  i2svg: function() {
    let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    return ee ? (ue("beforeI2svg", e), ie("pseudoElements2svg", e), ie("i2svg", e)) : Promise.reject(new Error("Operation requires a DOM of some kind."));
  },
  watch: function() {
    let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    const {
      autoReplaceSvgRoot: t
    } = e;
    v.autoReplaceSvg === !1 && (v.autoReplaceSvg = !0), v.observeMutations = !0, Ea(() => {
      qa({
        autoReplaceSvgRoot: t
      }), ue("watch", e);
    });
  }
}, Ya = {
  icon: (e) => {
    if (e === null)
      return null;
    if (typeof e == "object" && e.prefix && e.iconName)
      return {
        prefix: e.prefix,
        iconName: ce(e.prefix, e.iconName) || e.iconName
      };
    if (Array.isArray(e) && e.length === 2) {
      const t = e[1].indexOf("fa-") === 0 ? e[1].slice(3) : e[1], n = Ue(e[0]);
      return {
        prefix: n,
        iconName: ce(n, t) || t
      };
    }
    if (typeof e == "string" && (e.indexOf("".concat(v.cssPrefix, "-")) > -1 || e.match(la))) {
      const t = We(e.split(" "), {
        skipLookups: !0
      });
      return {
        prefix: t.prefix || ae(),
        iconName: ce(t.prefix, t.iconName) || t.iconName
      };
    }
    if (typeof e == "string") {
      const t = ae();
      return {
        prefix: t,
        iconName: ce(t, e) || e
      };
    }
  }
}, q = {
  noAuto: Ua,
  config: v,
  dom: Wa,
  parse: Ya,
  library: mr,
  findIconDefinition: Et,
  toHtml: Se
}, qa = function() {
  let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
  const {
    autoReplaceSvgRoot: t = $
  } = e;
  (Object.keys(Z.styles).length > 0 || v.autoFetchSvg) && ee && v.autoReplaceSvg && q.dom.i2svg({
    node: t
  });
};
function Ye(e, t) {
  return Object.defineProperty(e, "abstract", {
    get: t
  }), Object.defineProperty(e, "html", {
    get: function() {
      return e.abstract.map((n) => Se(n));
    }
  }), Object.defineProperty(e, "node", {
    get: function() {
      if (!ee) return;
      const n = $.createElement("div");
      return n.innerHTML = e.html, n.children;
    }
  }), e;
}
function Ha(e) {
  let {
    children: t,
    main: n,
    mask: r,
    attributes: a,
    styles: i,
    transform: o
  } = e;
  if (Lt(o) && n.found && !r.found) {
    const {
      width: s,
      height: d
    } = n, c = {
      x: s / d / 2,
      y: 0.5
    };
    a.style = $e(f(f({}, i), {}, {
      "transform-origin": "".concat(c.x + o.x / 16, "em ").concat(c.y + o.y / 16, "em")
    }));
  }
  return [{
    tag: "svg",
    attributes: a,
    children: t
  }];
}
function Ba(e) {
  let {
    prefix: t,
    iconName: n,
    children: r,
    attributes: a,
    symbol: i
  } = e;
  const o = i === !0 ? "".concat(t, "-").concat(v.cssPrefix, "-").concat(n) : i;
  return [{
    tag: "svg",
    attributes: {
      style: "display: none;"
    },
    children: [{
      tag: "symbol",
      attributes: f(f({}, a), {}, {
        id: o
      }),
      children: r
    }]
  }];
}
function $t(e) {
  const {
    icons: {
      main: t,
      mask: n
    },
    prefix: r,
    iconName: a,
    transform: i,
    symbol: o,
    title: s,
    maskId: d,
    titleId: c,
    extra: u,
    watchable: l = !1
  } = e, {
    width: b,
    height: x
  } = n.found ? n : t, j = Br.includes(r), P = [v.replacementClass, a ? "".concat(v.cssPrefix, "-").concat(a) : ""].filter((p) => u.classes.indexOf(p) === -1).filter((p) => p !== "" || !!p).concat(u.classes).join(" ");
  let A = {
    children: [],
    attributes: f(f({}, u.attributes), {}, {
      "data-prefix": r,
      "data-icon": a,
      class: P,
      role: u.attributes.role || "img",
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 ".concat(b, " ").concat(x)
    })
  };
  const F = j && !~u.classes.indexOf("fa-fw") ? {
    width: "".concat(b / x * 16 * 0.0625, "em")
  } : {};
  l && (A.attributes[fe] = ""), s && (A.children.push({
    tag: "title",
    attributes: {
      id: A.attributes["aria-labelledby"] || "title-".concat(c || Ae())
    },
    children: [s]
  }), delete A.attributes.title);
  const U = f(f({}, A), {}, {
    prefix: r,
    iconName: a,
    main: t,
    mask: n,
    maskId: d,
    transform: i,
    symbol: o,
    styles: f(f({}, F), u.styles)
  }), {
    children: k,
    attributes: L
  } = n.found && t.found ? ie("generateAbstractMask", U) || {
    children: [],
    attributes: {}
  } : ie("generateAbstractIcon", U) || {
    children: [],
    attributes: {}
  };
  return U.children = k, U.attributes = L, o ? Ba(U) : Ha(U);
}
function ln(e) {
  const {
    content: t,
    width: n,
    height: r,
    transform: a,
    title: i,
    extra: o,
    watchable: s = !1
  } = e, d = f(f(f({}, o.attributes), i ? {
    title: i
  } : {}), {}, {
    class: o.classes.join(" ")
  });
  s && (d[fe] = "");
  const c = f({}, o.styles);
  Lt(a) && (c.transform = xa({
    transform: a,
    startCentered: !0,
    width: n,
    height: r
  }), c["-webkit-transform"] = c.transform);
  const u = $e(c);
  u.length > 0 && (d.style = u);
  const l = [];
  return l.push({
    tag: "span",
    attributes: d,
    children: [t]
  }), i && l.push({
    tag: "span",
    attributes: {
      class: "sr-only"
    },
    children: [i]
  }), l;
}
function Va(e) {
  const {
    content: t,
    title: n,
    extra: r
  } = e, a = f(f(f({}, r.attributes), n ? {
    title: n
  } : {}), {}, {
    class: r.classes.join(" ")
  }), i = $e(r.styles);
  i.length > 0 && (a.style = i);
  const o = [];
  return o.push({
    tag: "span",
    attributes: a,
    children: [t]
  }), n && o.push({
    tag: "span",
    attributes: {
      class: "sr-only"
    },
    children: [n]
  }), o;
}
const {
  styles: Qe
} = Z;
function Ct(e) {
  const t = e[0], n = e[1], [r] = e.slice(4);
  let a = null;
  return Array.isArray(r) ? a = {
    tag: "g",
    attributes: {
      class: "".concat(v.cssPrefix, "-").concat(Ze.GROUP)
    },
    children: [{
      tag: "path",
      attributes: {
        class: "".concat(v.cssPrefix, "-").concat(Ze.SECONDARY),
        fill: "currentColor",
        d: r[0]
      }
    }, {
      tag: "path",
      attributes: {
        class: "".concat(v.cssPrefix, "-").concat(Ze.PRIMARY),
        fill: "currentColor",
        d: r[1]
      }
    }]
  } : a = {
    tag: "path",
    attributes: {
      fill: "currentColor",
      d: r
    }
  }, {
    found: !0,
    width: t,
    height: n,
    icon: a
  };
}
const Ga = {
  found: !1,
  width: 512,
  height: 512
};
function Xa(e, t) {
  !Zn && !v.showMissingIcons && e && console.error('Icon with name "'.concat(e, '" and prefix "').concat(t, '" is missing.'));
}
function St(e, t) {
  let n = t;
  return t === "fa" && v.styleDefault !== null && (t = ae()), new Promise((r, a) => {
    if (n === "fa") {
      const i = ur(e) || {};
      e = i.iconName || e, t = i.prefix || t;
    }
    if (e && t && Qe[t] && Qe[t][e]) {
      const i = Qe[t][e];
      return r(Ct(i));
    }
    Xa(e, t), r(f(f({}, Ga), {}, {
      icon: v.showMissingIcons && e ? ie("missingIconAbstract") || {} : {}
    }));
  });
}
const cn = () => {
}, Ot = v.measurePerformance && ke && ke.mark && ke.measure ? ke : {
  mark: cn,
  measure: cn
}, ve = 'FA "6.7.2"', Za = (e) => (Ot.mark("".concat(ve, " ").concat(e, " begins")), () => pr(e)), pr = (e) => {
  Ot.mark("".concat(ve, " ").concat(e, " ends")), Ot.measure("".concat(ve, " ").concat(e), "".concat(ve, " ").concat(e, " begins"), "".concat(ve, " ").concat(e, " ends"));
};
var Ut = {
  begin: Za,
  end: pr
};
const Fe = () => {
};
function fn(e) {
  return typeof (e.getAttribute ? e.getAttribute(fe) : null) == "string";
}
function Ka(e) {
  const t = e.getAttribute ? e.getAttribute(Ft) : null, n = e.getAttribute ? e.getAttribute(Rt) : null;
  return t && n;
}
function Ja(e) {
  return e && e.classList && e.classList.contains && e.classList.contains(v.replacementClass);
}
function Qa() {
  return v.autoReplaceSvg === !0 ? Re.replace : Re[v.autoReplaceSvg] || Re.replace;
}
function ei(e) {
  return $.createElementNS("http://www.w3.org/2000/svg", e);
}
function ti(e) {
  return $.createElement(e);
}
function gr(e) {
  let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
  const {
    ceFn: n = e.tag === "svg" ? ei : ti
  } = t;
  if (typeof e == "string")
    return $.createTextNode(e);
  const r = n(e.tag);
  return Object.keys(e.attributes || []).forEach(function(i) {
    r.setAttribute(i, e.attributes[i]);
  }), (e.children || []).forEach(function(i) {
    r.appendChild(gr(i, {
      ceFn: n
    }));
  }), r;
}
function ni(e) {
  let t = " ".concat(e.outerHTML, " ");
  return t = "".concat(t, "Font Awesome fontawesome.com "), t;
}
const Re = {
  replace: function(e) {
    const t = e[0];
    if (t.parentNode)
      if (e[1].forEach((n) => {
        t.parentNode.insertBefore(gr(n), t);
      }), t.getAttribute(fe) === null && v.keepOriginalSource) {
        let n = $.createComment(ni(t));
        t.parentNode.replaceChild(n, t);
      } else
        t.remove();
  },
  nest: function(e) {
    const t = e[0], n = e[1];
    if (~zt(t).indexOf(v.replacementClass))
      return Re.replace(e);
    const r = new RegExp("".concat(v.cssPrefix, "-.*"));
    if (delete n[0].attributes.id, n[0].attributes.class) {
      const i = n[0].attributes.class.split(" ").reduce((o, s) => (s === v.replacementClass || s.match(r) ? o.toSvg.push(s) : o.toNode.push(s), o), {
        toNode: [],
        toSvg: []
      });
      n[0].attributes.class = i.toSvg.join(" "), i.toNode.length === 0 ? t.removeAttribute("class") : t.setAttribute("class", i.toNode.join(" "));
    }
    const a = n.map((i) => Se(i)).join(`
`);
    t.setAttribute(fe, ""), t.innerHTML = a;
  }
};
function un(e) {
  e();
}
function hr(e, t) {
  const n = typeof t == "function" ? t : Fe;
  if (e.length === 0)
    n();
  else {
    let r = un;
    v.mutateApproach === ia && (r = re.requestAnimationFrame || un), r(() => {
      const a = Qa(), i = Ut.begin("mutate");
      e.map(a), i(), n();
    });
  }
}
let Wt = !1;
function br() {
  Wt = !0;
}
function Tt() {
  Wt = !1;
}
let ze = null;
function dn(e) {
  if (!Kt || !v.observeMutations)
    return;
  const {
    treeCallback: t = Fe,
    nodeCallback: n = Fe,
    pseudoElementsCallback: r = Fe,
    observeMutationsRoot: a = $
  } = e;
  ze = new Kt((i) => {
    if (Wt) return;
    const o = ae();
    be(i).forEach((s) => {
      if (s.type === "childList" && s.addedNodes.length > 0 && !fn(s.addedNodes[0]) && (v.searchPseudoElements && r(s.target), t(s.target)), s.type === "attributes" && s.target.parentNode && v.searchPseudoElements && r(s.target.parentNode), s.type === "attributes" && fn(s.target) && ~ua.indexOf(s.attributeName))
        if (s.attributeName === "class" && Ka(s.target)) {
          const {
            prefix: d,
            iconName: c
          } = We(zt(s.target));
          s.target.setAttribute(Ft, d || o), c && s.target.setAttribute(Rt, c);
        } else Ja(s.target) && n(s.target);
    });
  }), ee && ze.observe(a, {
    childList: !0,
    attributes: !0,
    characterData: !0,
    subtree: !0
  });
}
function ri() {
  ze && ze.disconnect();
}
function ai(e) {
  const t = e.getAttribute("style");
  let n = [];
  return t && (n = t.split(";").reduce((r, a) => {
    const i = a.split(":"), o = i[0], s = i.slice(1);
    return o && s.length > 0 && (r[o] = s.join(":").trim()), r;
  }, {})), n;
}
function ii(e) {
  const t = e.getAttribute("data-prefix"), n = e.getAttribute("data-icon"), r = e.innerText !== void 0 ? e.innerText.trim() : "";
  let a = We(zt(e));
  return a.prefix || (a.prefix = ae()), t && n && (a.prefix = t, a.iconName = n), a.iconName && a.prefix || (a.prefix && r.length > 0 && (a.iconName = _a(a.prefix, e.innerText) || Dt(a.prefix, xt(e.innerText))), !a.iconName && v.autoFetchSvg && e.firstChild && e.firstChild.nodeType === Node.TEXT_NODE && (a.iconName = e.firstChild.data)), a;
}
function oi(e) {
  const t = be(e.attributes).reduce((a, i) => (a.name !== "class" && a.name !== "style" && (a[i.name] = i.value), a), {}), n = e.getAttribute("title"), r = e.getAttribute("data-fa-title-id");
  return v.autoA11y && (n ? t["aria-labelledby"] = "".concat(v.replacementClass, "-title-").concat(r || Ae()) : (t["aria-hidden"] = "true", t.focusable = "false")), t;
}
function si() {
  return {
    iconName: null,
    title: null,
    titleId: null,
    prefix: null,
    transform: X,
    symbol: !1,
    mask: {
      iconName: null,
      prefix: null,
      rest: []
    },
    maskId: null,
    extra: {
      classes: [],
      styles: {},
      attributes: {}
    }
  };
}
function mn(e) {
  let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {
    styleParser: !0
  };
  const {
    iconName: n,
    prefix: r,
    rest: a
  } = ii(e), i = oi(e), o = At("parseNodeAttributes", {}, e);
  let s = t.styleParser ? ai(e) : [];
  return f({
    iconName: n,
    title: e.getAttribute("title"),
    titleId: e.getAttribute("data-fa-title-id"),
    prefix: r,
    transform: X,
    mask: {
      iconName: null,
      prefix: null,
      rest: []
    },
    maskId: null,
    symbol: !1,
    extra: {
      classes: a,
      styles: s,
      attributes: i
    }
  }, o);
}
const {
  styles: li
} = Z;
function yr(e) {
  const t = v.autoReplaceSvg === "nest" ? mn(e, {
    styleParser: !1
  }) : mn(e);
  return ~t.extra.classes.indexOf(Jn) ? ie("generateLayersText", e, t) : ie("generateSvgReplacementMutation", e, t);
}
function ci() {
  return [...Yr, ...pt];
}
function pn(e) {
  let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null;
  if (!ee) return Promise.resolve();
  const n = $.documentElement.classList, r = (u) => n.add("".concat(en, "-").concat(u)), a = (u) => n.remove("".concat(en, "-").concat(u)), i = v.autoFetchSvg ? ci() : Hn.concat(Object.keys(li));
  i.includes("fa") || i.push("fa");
  const o = [".".concat(Jn, ":not([").concat(fe, "])")].concat(i.map((u) => ".".concat(u, ":not([").concat(fe, "])"))).join(", ");
  if (o.length === 0)
    return Promise.resolve();
  let s = [];
  try {
    s = be(e.querySelectorAll(o));
  } catch {
  }
  if (s.length > 0)
    r("pending"), a("complete");
  else
    return Promise.resolve();
  const d = Ut.begin("onTree"), c = s.reduce((u, l) => {
    try {
      const b = yr(l);
      b && u.push(b);
    } catch (b) {
      Zn || b.name === "MissingIcon" && console.error(b);
    }
    return u;
  }, []);
  return new Promise((u, l) => {
    Promise.all(c).then((b) => {
      hr(b, () => {
        r("active"), r("complete"), a("pending"), typeof t == "function" && t(), d(), u();
      });
    }).catch((b) => {
      d(), l(b);
    });
  });
}
function fi(e) {
  let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null;
  yr(e).then((n) => {
    n && hr([n], t);
  });
}
function ui(e) {
  return function(t) {
    let n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    const r = (t || {}).icon ? t : Et(t || {});
    let {
      mask: a
    } = n;
    return a && (a = (a || {}).icon ? a : Et(a || {})), e(r, f(f({}, n), {}, {
      mask: a
    }));
  };
}
const di = function(e) {
  let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
  const {
    transform: n = X,
    symbol: r = !1,
    mask: a = null,
    maskId: i = null,
    title: o = null,
    titleId: s = null,
    classes: d = [],
    attributes: c = {},
    styles: u = {}
  } = t;
  if (!e) return;
  const {
    prefix: l,
    iconName: b,
    icon: x
  } = e;
  return Ye(f({
    type: "icon"
  }, e), () => (ue("beforeDOMElementCreation", {
    iconDefinition: e,
    params: t
  }), v.autoA11y && (o ? c["aria-labelledby"] = "".concat(v.replacementClass, "-title-").concat(s || Ae()) : (c["aria-hidden"] = "true", c.focusable = "false")), $t({
    icons: {
      main: Ct(x),
      mask: a ? Ct(a.icon) : {
        found: !1,
        width: null,
        height: null,
        icon: {}
      }
    },
    prefix: l,
    iconName: b,
    transform: f(f({}, X), n),
    symbol: r,
    title: o,
    maskId: i,
    titleId: s,
    extra: {
      attributes: c,
      styles: u,
      classes: d
    }
  })));
};
var mi = {
  mixout() {
    return {
      icon: ui(di)
    };
  },
  hooks() {
    return {
      mutationObserverCallbacks(e) {
        return e.treeCallback = pn, e.nodeCallback = fi, e;
      }
    };
  },
  provides(e) {
    e.i2svg = function(t) {
      const {
        node: n = $,
        callback: r = () => {
        }
      } = t;
      return pn(n, r);
    }, e.generateSvgReplacementMutation = function(t, n) {
      const {
        iconName: r,
        title: a,
        titleId: i,
        prefix: o,
        transform: s,
        symbol: d,
        mask: c,
        maskId: u,
        extra: l
      } = n;
      return new Promise((b, x) => {
        Promise.all([St(r, o), c.iconName ? St(c.iconName, c.prefix) : Promise.resolve({
          found: !1,
          width: 512,
          height: 512,
          icon: {}
        })]).then((j) => {
          let [P, A] = j;
          b([t, $t({
            icons: {
              main: P,
              mask: A
            },
            prefix: o,
            iconName: r,
            transform: s,
            symbol: d,
            maskId: u,
            title: a,
            titleId: i,
            extra: l,
            watchable: !0
          })]);
        }).catch(x);
      });
    }, e.generateAbstractIcon = function(t) {
      let {
        children: n,
        attributes: r,
        main: a,
        transform: i,
        styles: o
      } = t;
      const s = $e(o);
      s.length > 0 && (r.style = s);
      let d;
      return Lt(i) && (d = ie("generateAbstractTransformGrouping", {
        main: a,
        transform: i,
        containerWidth: a.width,
        iconWidth: a.width
      })), n.push(d || a.icon), {
        children: n,
        attributes: r
      };
    };
  }
}, pi = {
  mixout() {
    return {
      layer(e) {
        let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        const {
          classes: n = []
        } = t;
        return Ye({
          type: "layer"
        }, () => {
          ue("beforeDOMElementCreation", {
            assembler: e,
            params: t
          });
          let r = [];
          return e((a) => {
            Array.isArray(a) ? a.map((i) => {
              r = r.concat(i.abstract);
            }) : r = r.concat(a.abstract);
          }), [{
            tag: "span",
            attributes: {
              class: ["".concat(v.cssPrefix, "-layers"), ...n].join(" ")
            },
            children: r
          }];
        });
      }
    };
  }
}, gi = {
  mixout() {
    return {
      counter(e) {
        let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        const {
          title: n = null,
          classes: r = [],
          attributes: a = {},
          styles: i = {}
        } = t;
        return Ye({
          type: "counter",
          content: e
        }, () => (ue("beforeDOMElementCreation", {
          content: e,
          params: t
        }), Va({
          content: e.toString(),
          title: n,
          extra: {
            attributes: a,
            styles: i,
            classes: ["".concat(v.cssPrefix, "-layers-counter"), ...r]
          }
        })));
      }
    };
  }
}, hi = {
  mixout() {
    return {
      text(e) {
        let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        const {
          transform: n = X,
          title: r = null,
          classes: a = [],
          attributes: i = {},
          styles: o = {}
        } = t;
        return Ye({
          type: "text",
          content: e
        }, () => (ue("beforeDOMElementCreation", {
          content: e,
          params: t
        }), ln({
          content: e,
          transform: f(f({}, X), n),
          title: r,
          extra: {
            attributes: i,
            styles: o,
            classes: ["".concat(v.cssPrefix, "-layers-text"), ...a]
          }
        })));
      }
    };
  },
  provides(e) {
    e.generateLayersText = function(t, n) {
      const {
        title: r,
        transform: a,
        extra: i
      } = n;
      let o = null, s = null;
      if (Yn) {
        const d = parseInt(getComputedStyle(t).fontSize, 10), c = t.getBoundingClientRect();
        o = c.width / d, s = c.height / d;
      }
      return v.autoA11y && !r && (i.attributes["aria-hidden"] = "true"), Promise.resolve([t, ln({
        content: t.innerHTML,
        width: o,
        height: s,
        transform: a,
        title: r,
        extra: i,
        watchable: !0
      })]);
    };
  }
};
const bi = new RegExp('"', "ug"), gn = [1105920, 1112319], hn = f(f(f(f({}, {
  FontAwesome: {
    normal: "fas",
    400: "fas"
  }
}), $r), ra), Zr), Pt = Object.keys(hn).reduce((e, t) => (e[t.toLowerCase()] = hn[t], e), {}), yi = Object.keys(Pt).reduce((e, t) => {
  const n = Pt[t];
  return e[t] = n[900] || [...Object.entries(n)][0][1], e;
}, {});
function vi(e) {
  const t = e.replace(bi, ""), n = Sa(t, 0), r = n >= gn[0] && n <= gn[1], a = t.length === 2 ? t[0] === t[1] : !1;
  return {
    value: xt(a ? t[0] : t),
    isSecondary: r || a
  };
}
function xi(e, t) {
  const n = e.replace(/^['"]|['"]$/g, "").toLowerCase(), r = parseInt(t), a = isNaN(r) ? "normal" : r;
  return (Pt[n] || {})[a] || yi[n];
}
function bn(e, t) {
  const n = "".concat(aa).concat(t.replace(":", "-"));
  return new Promise((r, a) => {
    if (e.getAttribute(n) !== null)
      return r();
    const o = be(e.children).filter((b) => b.getAttribute(ht) === t)[0], s = re.getComputedStyle(e, t), d = s.getPropertyValue("font-family"), c = d.match(ca), u = s.getPropertyValue("font-weight"), l = s.getPropertyValue("content");
    if (o && !c)
      return e.removeChild(o), r();
    if (c && l !== "none" && l !== "") {
      const b = s.getPropertyValue("content");
      let x = xi(d, u);
      const {
        value: j,
        isSecondary: P
      } = vi(b), A = c[0].startsWith("FontAwesome");
      let F = Dt(x, j), U = F;
      if (A) {
        const k = Na(j);
        k.iconName && k.prefix && (F = k.iconName, x = k.prefix);
      }
      if (F && !P && (!o || o.getAttribute(Ft) !== x || o.getAttribute(Rt) !== U)) {
        e.setAttribute(n, U), o && e.removeChild(o);
        const k = si(), {
          extra: L
        } = k;
        L.attributes[ht] = t, St(F, x).then((p) => {
          const K = $t(f(f({}, k), {}, {
            icons: {
              main: p,
              mask: dr()
            },
            prefix: x,
            iconName: U,
            extra: L,
            watchable: !0
          })), oe = $.createElementNS("http://www.w3.org/2000/svg", "svg");
          t === "::before" ? e.insertBefore(oe, e.firstChild) : e.appendChild(oe), oe.outerHTML = K.map((ye) => Se(ye)).join(`
`), e.removeAttribute(n), r();
        }).catch(a);
      } else
        r();
    } else
      r();
  });
}
function wi(e) {
  return Promise.all([bn(e, "::before"), bn(e, "::after")]);
}
function Ai(e) {
  return e.parentNode !== document.head && !~oa.indexOf(e.tagName.toUpperCase()) && !e.getAttribute(ht) && (!e.parentNode || e.parentNode.tagName !== "svg");
}
function yn(e) {
  if (ee)
    return new Promise((t, n) => {
      const r = be(e.querySelectorAll("*")).filter(Ai).map(wi), a = Ut.begin("searchPseudoElements");
      br(), Promise.all(r).then(() => {
        a(), Tt(), t();
      }).catch(() => {
        a(), Tt(), n();
      });
    });
}
var Ei = {
  hooks() {
    return {
      mutationObserverCallbacks(e) {
        return e.pseudoElementsCallback = yn, e;
      }
    };
  },
  provides(e) {
    e.pseudoElements2svg = function(t) {
      const {
        node: n = $
      } = t;
      v.searchPseudoElements && yn(n);
    };
  }
};
let vn = !1;
var Ci = {
  mixout() {
    return {
      dom: {
        unwatch() {
          br(), vn = !0;
        }
      }
    };
  },
  hooks() {
    return {
      bootstrap() {
        dn(At("mutationObserverCallbacks", {}));
      },
      noAuto() {
        ri();
      },
      watch(e) {
        const {
          observeMutationsRoot: t
        } = e;
        vn ? Tt() : dn(At("mutationObserverCallbacks", {
          observeMutationsRoot: t
        }));
      }
    };
  }
};
const xn = (e) => {
  let t = {
    size: 16,
    x: 0,
    y: 0,
    flipX: !1,
    flipY: !1,
    rotate: 0
  };
  return e.toLowerCase().split(" ").reduce((n, r) => {
    const a = r.toLowerCase().split("-"), i = a[0];
    let o = a.slice(1).join("-");
    if (i && o === "h")
      return n.flipX = !0, n;
    if (i && o === "v")
      return n.flipY = !0, n;
    if (o = parseFloat(o), isNaN(o))
      return n;
    switch (i) {
      case "grow":
        n.size = n.size + o;
        break;
      case "shrink":
        n.size = n.size - o;
        break;
      case "left":
        n.x = n.x - o;
        break;
      case "right":
        n.x = n.x + o;
        break;
      case "up":
        n.y = n.y - o;
        break;
      case "down":
        n.y = n.y + o;
        break;
      case "rotate":
        n.rotate = n.rotate + o;
        break;
    }
    return n;
  }, t);
};
var Si = {
  mixout() {
    return {
      parse: {
        transform: (e) => xn(e)
      }
    };
  },
  hooks() {
    return {
      parseNodeAttributes(e, t) {
        const n = t.getAttribute("data-fa-transform");
        return n && (e.transform = xn(n)), e;
      }
    };
  },
  provides(e) {
    e.generateAbstractTransformGrouping = function(t) {
      let {
        main: n,
        transform: r,
        containerWidth: a,
        iconWidth: i
      } = t;
      const o = {
        transform: "translate(".concat(a / 2, " 256)")
      }, s = "translate(".concat(r.x * 32, ", ").concat(r.y * 32, ") "), d = "scale(".concat(r.size / 16 * (r.flipX ? -1 : 1), ", ").concat(r.size / 16 * (r.flipY ? -1 : 1), ") "), c = "rotate(".concat(r.rotate, " 0 0)"), u = {
        transform: "".concat(s, " ").concat(d, " ").concat(c)
      }, l = {
        transform: "translate(".concat(i / 2 * -1, " -256)")
      }, b = {
        outer: o,
        inner: u,
        path: l
      };
      return {
        tag: "g",
        attributes: f({}, b.outer),
        children: [{
          tag: "g",
          attributes: f({}, b.inner),
          children: [{
            tag: n.icon.tag,
            children: n.icon.children,
            attributes: f(f({}, n.icon.attributes), b.path)
          }]
        }]
      };
    };
  }
};
const et = {
  x: 0,
  y: 0,
  width: "100%",
  height: "100%"
};
function wn(e) {
  let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !0;
  return e.attributes && (e.attributes.fill || t) && (e.attributes.fill = "black"), e;
}
function Oi(e) {
  return e.tag === "g" ? e.children : [e];
}
var Ti = {
  hooks() {
    return {
      parseNodeAttributes(e, t) {
        const n = t.getAttribute("data-fa-mask"), r = n ? We(n.split(" ").map((a) => a.trim())) : dr();
        return r.prefix || (r.prefix = ae()), e.mask = r, e.maskId = t.getAttribute("data-fa-mask-id"), e;
      }
    };
  },
  provides(e) {
    e.generateAbstractMask = function(t) {
      let {
        children: n,
        attributes: r,
        main: a,
        mask: i,
        maskId: o,
        transform: s
      } = t;
      const {
        width: d,
        icon: c
      } = a, {
        width: u,
        icon: l
      } = i, b = va({
        transform: s,
        containerWidth: u,
        iconWidth: d
      }), x = {
        tag: "rect",
        attributes: f(f({}, et), {}, {
          fill: "white"
        })
      }, j = c.children ? {
        children: c.children.map(wn)
      } : {}, P = {
        tag: "g",
        attributes: f({}, b.inner),
        children: [wn(f({
          tag: c.tag,
          attributes: f(f({}, c.attributes), b.path)
        }, j))]
      }, A = {
        tag: "g",
        attributes: f({}, b.outer),
        children: [P]
      }, F = "mask-".concat(o || Ae()), U = "clip-".concat(o || Ae()), k = {
        tag: "mask",
        attributes: f(f({}, et), {}, {
          id: F,
          maskUnits: "userSpaceOnUse",
          maskContentUnits: "userSpaceOnUse"
        }),
        children: [x, A]
      }, L = {
        tag: "defs",
        children: [{
          tag: "clipPath",
          attributes: {
            id: U
          },
          children: Oi(l)
        }, k]
      };
      return n.push(L, {
        tag: "rect",
        attributes: f({
          fill: "currentColor",
          "clip-path": "url(#".concat(U, ")"),
          mask: "url(#".concat(F, ")")
        }, et)
      }), {
        children: n,
        attributes: r
      };
    };
  }
}, Pi = {
  provides(e) {
    let t = !1;
    re.matchMedia && (t = re.matchMedia("(prefers-reduced-motion: reduce)").matches), e.missingIconAbstract = function() {
      const n = [], r = {
        fill: "currentColor"
      }, a = {
        attributeType: "XML",
        repeatCount: "indefinite",
        dur: "2s"
      };
      n.push({
        tag: "path",
        attributes: f(f({}, r), {}, {
          d: "M156.5,447.7l-12.6,29.5c-18.7-9.5-35.9-21.2-51.5-34.9l22.7-22.7C127.6,430.5,141.5,440,156.5,447.7z M40.6,272H8.5 c1.4,21.2,5.4,41.7,11.7,61.1L50,321.2C45.1,305.5,41.8,289,40.6,272z M40.6,240c1.4-18.8,5.2-37,11.1-54.1l-29.5-12.6 C14.7,194.3,10,216.7,8.5,240H40.6z M64.3,156.5c7.8-14.9,17.2-28.8,28.1-41.5L69.7,92.3c-13.7,15.6-25.5,32.8-34.9,51.5 L64.3,156.5z M397,419.6c-13.9,12-29.4,22.3-46.1,30.4l11.9,29.8c20.7-9.9,39.8-22.6,56.9-37.6L397,419.6z M115,92.4 c13.9-12,29.4-22.3,46.1-30.4l-11.9-29.8c-20.7,9.9-39.8,22.6-56.8,37.6L115,92.4z M447.7,355.5c-7.8,14.9-17.2,28.8-28.1,41.5 l22.7,22.7c13.7-15.6,25.5-32.9,34.9-51.5L447.7,355.5z M471.4,272c-1.4,18.8-5.2,37-11.1,54.1l29.5,12.6 c7.5-21.1,12.2-43.5,13.6-66.8H471.4z M321.2,462c-15.7,5-32.2,8.2-49.2,9.4v32.1c21.2-1.4,41.7-5.4,61.1-11.7L321.2,462z M240,471.4c-18.8-1.4-37-5.2-54.1-11.1l-12.6,29.5c21.1,7.5,43.5,12.2,66.8,13.6V471.4z M462,190.8c5,15.7,8.2,32.2,9.4,49.2h32.1 c-1.4-21.2-5.4-41.7-11.7-61.1L462,190.8z M92.4,397c-12-13.9-22.3-29.4-30.4-46.1l-29.8,11.9c9.9,20.7,22.6,39.8,37.6,56.9 L92.4,397z M272,40.6c18.8,1.4,36.9,5.2,54.1,11.1l12.6-29.5C317.7,14.7,295.3,10,272,8.5V40.6z M190.8,50 c15.7-5,32.2-8.2,49.2-9.4V8.5c-21.2,1.4-41.7,5.4-61.1,11.7L190.8,50z M442.3,92.3L419.6,115c12,13.9,22.3,29.4,30.5,46.1 l29.8-11.9C470,128.5,457.3,109.4,442.3,92.3z M397,92.4l22.7-22.7c-15.6-13.7-32.8-25.5-51.5-34.9l-12.6,29.5 C370.4,72.1,384.4,81.5,397,92.4z"
        })
      });
      const i = f(f({}, a), {}, {
        attributeName: "opacity"
      }), o = {
        tag: "circle",
        attributes: f(f({}, r), {}, {
          cx: "256",
          cy: "364",
          r: "28"
        }),
        children: []
      };
      return t || o.children.push({
        tag: "animate",
        attributes: f(f({}, a), {}, {
          attributeName: "r",
          values: "28;14;28;28;14;28;"
        })
      }, {
        tag: "animate",
        attributes: f(f({}, i), {}, {
          values: "1;0;1;1;0;1;"
        })
      }), n.push(o), n.push({
        tag: "path",
        attributes: f(f({}, r), {}, {
          opacity: "1",
          d: "M263.7,312h-16c-6.6,0-12-5.4-12-12c0-71,77.4-63.9,77.4-107.8c0-20-17.8-40.2-57.4-40.2c-29.1,0-44.3,9.6-59.2,28.7 c-3.9,5-11.1,6-16.2,2.4l-13.1-9.2c-5.6-3.9-6.9-11.8-2.6-17.2c21.2-27.2,46.4-44.7,91.2-44.7c52.3,0,97.4,29.8,97.4,80.2 c0,67.6-77.4,63.5-77.4,107.8C275.7,306.6,270.3,312,263.7,312z"
        }),
        children: t ? [] : [{
          tag: "animate",
          attributes: f(f({}, i), {}, {
            values: "1;0;0;0;0;1;"
          })
        }]
      }), t || n.push({
        tag: "path",
        attributes: f(f({}, r), {}, {
          opacity: "0",
          d: "M232.5,134.5l7,168c0.3,6.4,5.6,11.5,12,11.5h9c6.4,0,11.7-5.1,12-11.5l7-168c0.3-6.8-5.2-12.5-12-12.5h-23 C237.7,122,232.2,127.7,232.5,134.5z"
        }),
        children: [{
          tag: "animate",
          attributes: f(f({}, i), {}, {
            values: "0;0;1;1;0;0;"
          })
        }]
      }), {
        tag: "g",
        attributes: {
          class: "missing"
        },
        children: n
      };
    };
  }
}, ki = {
  hooks() {
    return {
      parseNodeAttributes(e, t) {
        const n = t.getAttribute("data-fa-symbol"), r = n === null ? !1 : n === "" ? !0 : n;
        return e.symbol = r, e;
      }
    };
  }
}, _i = [Aa, mi, pi, gi, hi, Ei, Ci, Si, Ti, Pi, ki];
$a(_i, {
  mixoutsTo: q
});
q.noAuto;
q.config;
q.library;
q.dom;
const kt = q.parse;
q.findIconDefinition;
q.toHtml;
const Ni = q.icon;
q.layer;
q.text;
q.counter;
function vr(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var Ne = { exports: {} }, Ie = { exports: {} }, R = {};
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var An;
function Ii() {
  if (An) return R;
  An = 1;
  var e = typeof Symbol == "function" && Symbol.for, t = e ? Symbol.for("react.element") : 60103, n = e ? Symbol.for("react.portal") : 60106, r = e ? Symbol.for("react.fragment") : 60107, a = e ? Symbol.for("react.strict_mode") : 60108, i = e ? Symbol.for("react.profiler") : 60114, o = e ? Symbol.for("react.provider") : 60109, s = e ? Symbol.for("react.context") : 60110, d = e ? Symbol.for("react.async_mode") : 60111, c = e ? Symbol.for("react.concurrent_mode") : 60111, u = e ? Symbol.for("react.forward_ref") : 60112, l = e ? Symbol.for("react.suspense") : 60113, b = e ? Symbol.for("react.suspense_list") : 60120, x = e ? Symbol.for("react.memo") : 60115, j = e ? Symbol.for("react.lazy") : 60116, P = e ? Symbol.for("react.block") : 60121, A = e ? Symbol.for("react.fundamental") : 60117, F = e ? Symbol.for("react.responder") : 60118, U = e ? Symbol.for("react.scope") : 60119;
  function k(p) {
    if (typeof p == "object" && p !== null) {
      var K = p.$$typeof;
      switch (K) {
        case t:
          switch (p = p.type, p) {
            case d:
            case c:
            case r:
            case i:
            case a:
            case l:
              return p;
            default:
              switch (p = p && p.$$typeof, p) {
                case s:
                case u:
                case j:
                case x:
                case o:
                  return p;
                default:
                  return K;
              }
          }
        case n:
          return K;
      }
    }
  }
  function L(p) {
    return k(p) === c;
  }
  return R.AsyncMode = d, R.ConcurrentMode = c, R.ContextConsumer = s, R.ContextProvider = o, R.Element = t, R.ForwardRef = u, R.Fragment = r, R.Lazy = j, R.Memo = x, R.Portal = n, R.Profiler = i, R.StrictMode = a, R.Suspense = l, R.isAsyncMode = function(p) {
    return L(p) || k(p) === d;
  }, R.isConcurrentMode = L, R.isContextConsumer = function(p) {
    return k(p) === s;
  }, R.isContextProvider = function(p) {
    return k(p) === o;
  }, R.isElement = function(p) {
    return typeof p == "object" && p !== null && p.$$typeof === t;
  }, R.isForwardRef = function(p) {
    return k(p) === u;
  }, R.isFragment = function(p) {
    return k(p) === r;
  }, R.isLazy = function(p) {
    return k(p) === j;
  }, R.isMemo = function(p) {
    return k(p) === x;
  }, R.isPortal = function(p) {
    return k(p) === n;
  }, R.isProfiler = function(p) {
    return k(p) === i;
  }, R.isStrictMode = function(p) {
    return k(p) === a;
  }, R.isSuspense = function(p) {
    return k(p) === l;
  }, R.isValidElementType = function(p) {
    return typeof p == "string" || typeof p == "function" || p === r || p === c || p === i || p === a || p === l || p === b || typeof p == "object" && p !== null && (p.$$typeof === j || p.$$typeof === x || p.$$typeof === o || p.$$typeof === s || p.$$typeof === u || p.$$typeof === A || p.$$typeof === F || p.$$typeof === U || p.$$typeof === P);
  }, R.typeOf = k, R;
}
var M = {};
/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var En;
function Fi() {
  return En || (En = 1, process.env.NODE_ENV !== "production" && function() {
    var e = typeof Symbol == "function" && Symbol.for, t = e ? Symbol.for("react.element") : 60103, n = e ? Symbol.for("react.portal") : 60106, r = e ? Symbol.for("react.fragment") : 60107, a = e ? Symbol.for("react.strict_mode") : 60108, i = e ? Symbol.for("react.profiler") : 60114, o = e ? Symbol.for("react.provider") : 60109, s = e ? Symbol.for("react.context") : 60110, d = e ? Symbol.for("react.async_mode") : 60111, c = e ? Symbol.for("react.concurrent_mode") : 60111, u = e ? Symbol.for("react.forward_ref") : 60112, l = e ? Symbol.for("react.suspense") : 60113, b = e ? Symbol.for("react.suspense_list") : 60120, x = e ? Symbol.for("react.memo") : 60115, j = e ? Symbol.for("react.lazy") : 60116, P = e ? Symbol.for("react.block") : 60121, A = e ? Symbol.for("react.fundamental") : 60117, F = e ? Symbol.for("react.responder") : 60118, U = e ? Symbol.for("react.scope") : 60119;
    function k(h) {
      return typeof h == "string" || typeof h == "function" || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
      h === r || h === c || h === i || h === a || h === l || h === b || typeof h == "object" && h !== null && (h.$$typeof === j || h.$$typeof === x || h.$$typeof === o || h.$$typeof === s || h.$$typeof === u || h.$$typeof === A || h.$$typeof === F || h.$$typeof === U || h.$$typeof === P);
    }
    function L(h) {
      if (typeof h == "object" && h !== null) {
        var B = h.$$typeof;
        switch (B) {
          case t:
            var Pe = h.type;
            switch (Pe) {
              case d:
              case c:
              case r:
              case i:
              case a:
              case l:
                return Pe;
              default:
                var Bt = Pe && Pe.$$typeof;
                switch (Bt) {
                  case s:
                  case u:
                  case j:
                  case x:
                  case o:
                    return Bt;
                  default:
                    return B;
                }
            }
          case n:
            return B;
        }
      }
    }
    var p = d, K = c, oe = s, ye = o, qe = t, He = u, Oe = r, Be = j, Ve = x, de = n, Ge = i, H = a, se = l, Te = !1;
    function Xe(h) {
      return Te || (Te = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.")), m(h) || L(h) === d;
    }
    function m(h) {
      return L(h) === c;
    }
    function y(h) {
      return L(h) === s;
    }
    function T(h) {
      return L(h) === o;
    }
    function S(h) {
      return typeof h == "object" && h !== null && h.$$typeof === t;
    }
    function w(h) {
      return L(h) === u;
    }
    function _(h) {
      return L(h) === r;
    }
    function E(h) {
      return L(h) === j;
    }
    function O(h) {
      return L(h) === x;
    }
    function N(h) {
      return L(h) === n;
    }
    function z(h) {
      return L(h) === i;
    }
    function I(h) {
      return L(h) === a;
    }
    function Y(h) {
      return L(h) === l;
    }
    M.AsyncMode = p, M.ConcurrentMode = K, M.ContextConsumer = oe, M.ContextProvider = ye, M.Element = qe, M.ForwardRef = He, M.Fragment = Oe, M.Lazy = Be, M.Memo = Ve, M.Portal = de, M.Profiler = Ge, M.StrictMode = H, M.Suspense = se, M.isAsyncMode = Xe, M.isConcurrentMode = m, M.isContextConsumer = y, M.isContextProvider = T, M.isElement = S, M.isForwardRef = w, M.isFragment = _, M.isLazy = E, M.isMemo = O, M.isPortal = N, M.isProfiler = z, M.isStrictMode = I, M.isSuspense = Y, M.isValidElementType = k, M.typeOf = L;
  }()), M;
}
var Cn;
function xr() {
  return Cn || (Cn = 1, process.env.NODE_ENV === "production" ? Ie.exports = Ii() : Ie.exports = Fi()), Ie.exports;
}
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/
var tt, Sn;
function Ri() {
  if (Sn) return tt;
  Sn = 1;
  var e = Object.getOwnPropertySymbols, t = Object.prototype.hasOwnProperty, n = Object.prototype.propertyIsEnumerable;
  function r(i) {
    if (i == null)
      throw new TypeError("Object.assign cannot be called with null or undefined");
    return Object(i);
  }
  function a() {
    try {
      if (!Object.assign)
        return !1;
      var i = new String("abc");
      if (i[5] = "de", Object.getOwnPropertyNames(i)[0] === "5")
        return !1;
      for (var o = {}, s = 0; s < 10; s++)
        o["_" + String.fromCharCode(s)] = s;
      var d = Object.getOwnPropertyNames(o).map(function(u) {
        return o[u];
      });
      if (d.join("") !== "0123456789")
        return !1;
      var c = {};
      return "abcdefghijklmnopqrst".split("").forEach(function(u) {
        c[u] = u;
      }), Object.keys(Object.assign({}, c)).join("") === "abcdefghijklmnopqrst";
    } catch {
      return !1;
    }
  }
  return tt = a() ? Object.assign : function(i, o) {
    for (var s, d = r(i), c, u = 1; u < arguments.length; u++) {
      s = Object(arguments[u]);
      for (var l in s)
        t.call(s, l) && (d[l] = s[l]);
      if (e) {
        c = e(s);
        for (var b = 0; b < c.length; b++)
          n.call(s, c[b]) && (d[c[b]] = s[c[b]]);
      }
    }
    return d;
  }, tt;
}
var nt, On;
function Yt() {
  if (On) return nt;
  On = 1;
  var e = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
  return nt = e, nt;
}
var rt, Tn;
function wr() {
  return Tn || (Tn = 1, rt = Function.call.bind(Object.prototype.hasOwnProperty)), rt;
}
var at, Pn;
function Mi() {
  if (Pn) return at;
  Pn = 1;
  var e = function() {
  };
  if (process.env.NODE_ENV !== "production") {
    var t = /* @__PURE__ */ Yt(), n = {}, r = /* @__PURE__ */ wr();
    e = function(i) {
      var o = "Warning: " + i;
      typeof console < "u" && console.error(o);
      try {
        throw new Error(o);
      } catch {
      }
    };
  }
  function a(i, o, s, d, c) {
    if (process.env.NODE_ENV !== "production") {
      for (var u in i)
        if (r(i, u)) {
          var l;
          try {
            if (typeof i[u] != "function") {
              var b = Error(
                (d || "React class") + ": " + s + " type `" + u + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof i[u] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`."
              );
              throw b.name = "Invariant Violation", b;
            }
            l = i[u](o, u, d, s, null, t);
          } catch (j) {
            l = j;
          }
          if (l && !(l instanceof Error) && e(
            (d || "React class") + ": type specification of " + s + " `" + u + "` is invalid; the type checker function must return `null` or an `Error` but returned a " + typeof l + ". You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument)."
          ), l instanceof Error && !(l.message in n)) {
            n[l.message] = !0;
            var x = c ? c() : "";
            e(
              "Failed " + s + " type: " + l.message + (x ?? "")
            );
          }
        }
    }
  }
  return a.resetWarningCache = function() {
    process.env.NODE_ENV !== "production" && (n = {});
  }, at = a, at;
}
var it, kn;
function zi() {
  if (kn) return it;
  kn = 1;
  var e = xr(), t = Ri(), n = /* @__PURE__ */ Yt(), r = /* @__PURE__ */ wr(), a = /* @__PURE__ */ Mi(), i = function() {
  };
  process.env.NODE_ENV !== "production" && (i = function(s) {
    var d = "Warning: " + s;
    typeof console < "u" && console.error(d);
    try {
      throw new Error(d);
    } catch {
    }
  });
  function o() {
    return null;
  }
  return it = function(s, d) {
    var c = typeof Symbol == "function" && Symbol.iterator, u = "@@iterator";
    function l(m) {
      var y = m && (c && m[c] || m[u]);
      if (typeof y == "function")
        return y;
    }
    var b = "<<anonymous>>", x = {
      array: F("array"),
      bigint: F("bigint"),
      bool: F("boolean"),
      func: F("function"),
      number: F("number"),
      object: F("object"),
      string: F("string"),
      symbol: F("symbol"),
      any: U(),
      arrayOf: k,
      element: L(),
      elementType: p(),
      instanceOf: K,
      node: He(),
      objectOf: ye,
      oneOf: oe,
      oneOfType: qe,
      shape: Be,
      exact: Ve
    };
    function j(m, y) {
      return m === y ? m !== 0 || 1 / m === 1 / y : m !== m && y !== y;
    }
    function P(m, y) {
      this.message = m, this.data = y && typeof y == "object" ? y : {}, this.stack = "";
    }
    P.prototype = Error.prototype;
    function A(m) {
      if (process.env.NODE_ENV !== "production")
        var y = {}, T = 0;
      function S(_, E, O, N, z, I, Y) {
        if (N = N || b, I = I || O, Y !== n) {
          if (d) {
            var h = new Error(
              "Calling PropTypes validators directly is not supported by the `prop-types` package. Use `PropTypes.checkPropTypes()` to call them. Read more at http://fb.me/use-check-prop-types"
            );
            throw h.name = "Invariant Violation", h;
          } else if (process.env.NODE_ENV !== "production" && typeof console < "u") {
            var B = N + ":" + O;
            !y[B] && // Avoid spamming the console because they are often not actionable except for lib authors
            T < 3 && (i(
              "You are manually calling a React.PropTypes validation function for the `" + I + "` prop on `" + N + "`. This is deprecated and will throw in the standalone `prop-types` package. You may be seeing this warning due to a third-party PropTypes library. See https://fb.me/react-warning-dont-call-proptypes for details."
            ), y[B] = !0, T++);
          }
        }
        return E[O] == null ? _ ? E[O] === null ? new P("The " + z + " `" + I + "` is marked as required " + ("in `" + N + "`, but its value is `null`.")) : new P("The " + z + " `" + I + "` is marked as required in " + ("`" + N + "`, but its value is `undefined`.")) : null : m(E, O, N, z, I);
      }
      var w = S.bind(null, !1);
      return w.isRequired = S.bind(null, !0), w;
    }
    function F(m) {
      function y(T, S, w, _, E, O) {
        var N = T[S], z = H(N);
        if (z !== m) {
          var I = se(N);
          return new P(
            "Invalid " + _ + " `" + E + "` of type " + ("`" + I + "` supplied to `" + w + "`, expected ") + ("`" + m + "`."),
            { expectedType: m }
          );
        }
        return null;
      }
      return A(y);
    }
    function U() {
      return A(o);
    }
    function k(m) {
      function y(T, S, w, _, E) {
        if (typeof m != "function")
          return new P("Property `" + E + "` of component `" + w + "` has invalid PropType notation inside arrayOf.");
        var O = T[S];
        if (!Array.isArray(O)) {
          var N = H(O);
          return new P("Invalid " + _ + " `" + E + "` of type " + ("`" + N + "` supplied to `" + w + "`, expected an array."));
        }
        for (var z = 0; z < O.length; z++) {
          var I = m(O, z, w, _, E + "[" + z + "]", n);
          if (I instanceof Error)
            return I;
        }
        return null;
      }
      return A(y);
    }
    function L() {
      function m(y, T, S, w, _) {
        var E = y[T];
        if (!s(E)) {
          var O = H(E);
          return new P("Invalid " + w + " `" + _ + "` of type " + ("`" + O + "` supplied to `" + S + "`, expected a single ReactElement."));
        }
        return null;
      }
      return A(m);
    }
    function p() {
      function m(y, T, S, w, _) {
        var E = y[T];
        if (!e.isValidElementType(E)) {
          var O = H(E);
          return new P("Invalid " + w + " `" + _ + "` of type " + ("`" + O + "` supplied to `" + S + "`, expected a single ReactElement type."));
        }
        return null;
      }
      return A(m);
    }
    function K(m) {
      function y(T, S, w, _, E) {
        if (!(T[S] instanceof m)) {
          var O = m.name || b, N = Xe(T[S]);
          return new P("Invalid " + _ + " `" + E + "` of type " + ("`" + N + "` supplied to `" + w + "`, expected ") + ("instance of `" + O + "`."));
        }
        return null;
      }
      return A(y);
    }
    function oe(m) {
      if (!Array.isArray(m))
        return process.env.NODE_ENV !== "production" && (arguments.length > 1 ? i(
          "Invalid arguments supplied to oneOf, expected an array, got " + arguments.length + " arguments. A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z])."
        ) : i("Invalid argument supplied to oneOf, expected an array.")), o;
      function y(T, S, w, _, E) {
        for (var O = T[S], N = 0; N < m.length; N++)
          if (j(O, m[N]))
            return null;
        var z = JSON.stringify(m, function(Y, h) {
          var B = se(h);
          return B === "symbol" ? String(h) : h;
        });
        return new P("Invalid " + _ + " `" + E + "` of value `" + String(O) + "` " + ("supplied to `" + w + "`, expected one of " + z + "."));
      }
      return A(y);
    }
    function ye(m) {
      function y(T, S, w, _, E) {
        if (typeof m != "function")
          return new P("Property `" + E + "` of component `" + w + "` has invalid PropType notation inside objectOf.");
        var O = T[S], N = H(O);
        if (N !== "object")
          return new P("Invalid " + _ + " `" + E + "` of type " + ("`" + N + "` supplied to `" + w + "`, expected an object."));
        for (var z in O)
          if (r(O, z)) {
            var I = m(O, z, w, _, E + "." + z, n);
            if (I instanceof Error)
              return I;
          }
        return null;
      }
      return A(y);
    }
    function qe(m) {
      if (!Array.isArray(m))
        return process.env.NODE_ENV !== "production" && i("Invalid argument supplied to oneOfType, expected an instance of array."), o;
      for (var y = 0; y < m.length; y++) {
        var T = m[y];
        if (typeof T != "function")
          return i(
            "Invalid argument supplied to oneOfType. Expected an array of check functions, but received " + Te(T) + " at index " + y + "."
          ), o;
      }
      function S(w, _, E, O, N) {
        for (var z = [], I = 0; I < m.length; I++) {
          var Y = m[I], h = Y(w, _, E, O, N, n);
          if (h == null)
            return null;
          h.data && r(h.data, "expectedType") && z.push(h.data.expectedType);
        }
        var B = z.length > 0 ? ", expected one of type [" + z.join(", ") + "]" : "";
        return new P("Invalid " + O + " `" + N + "` supplied to " + ("`" + E + "`" + B + "."));
      }
      return A(S);
    }
    function He() {
      function m(y, T, S, w, _) {
        return de(y[T]) ? null : new P("Invalid " + w + " `" + _ + "` supplied to " + ("`" + S + "`, expected a ReactNode."));
      }
      return A(m);
    }
    function Oe(m, y, T, S, w) {
      return new P(
        (m || "React class") + ": " + y + " type `" + T + "." + S + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + w + "`."
      );
    }
    function Be(m) {
      function y(T, S, w, _, E) {
        var O = T[S], N = H(O);
        if (N !== "object")
          return new P("Invalid " + _ + " `" + E + "` of type `" + N + "` " + ("supplied to `" + w + "`, expected `object`."));
        for (var z in m) {
          var I = m[z];
          if (typeof I != "function")
            return Oe(w, _, E, z, se(I));
          var Y = I(O, z, w, _, E + "." + z, n);
          if (Y)
            return Y;
        }
        return null;
      }
      return A(y);
    }
    function Ve(m) {
      function y(T, S, w, _, E) {
        var O = T[S], N = H(O);
        if (N !== "object")
          return new P("Invalid " + _ + " `" + E + "` of type `" + N + "` " + ("supplied to `" + w + "`, expected `object`."));
        var z = t({}, T[S], m);
        for (var I in z) {
          var Y = m[I];
          if (r(m, I) && typeof Y != "function")
            return Oe(w, _, E, I, se(Y));
          if (!Y)
            return new P(
              "Invalid " + _ + " `" + E + "` key `" + I + "` supplied to `" + w + "`.\nBad object: " + JSON.stringify(T[S], null, "  ") + `
Valid keys: ` + JSON.stringify(Object.keys(m), null, "  ")
            );
          var h = Y(O, I, w, _, E + "." + I, n);
          if (h)
            return h;
        }
        return null;
      }
      return A(y);
    }
    function de(m) {
      switch (typeof m) {
        case "number":
        case "string":
        case "undefined":
          return !0;
        case "boolean":
          return !m;
        case "object":
          if (Array.isArray(m))
            return m.every(de);
          if (m === null || s(m))
            return !0;
          var y = l(m);
          if (y) {
            var T = y.call(m), S;
            if (y !== m.entries) {
              for (; !(S = T.next()).done; )
                if (!de(S.value))
                  return !1;
            } else
              for (; !(S = T.next()).done; ) {
                var w = S.value;
                if (w && !de(w[1]))
                  return !1;
              }
          } else
            return !1;
          return !0;
        default:
          return !1;
      }
    }
    function Ge(m, y) {
      return m === "symbol" ? !0 : y ? y["@@toStringTag"] === "Symbol" || typeof Symbol == "function" && y instanceof Symbol : !1;
    }
    function H(m) {
      var y = typeof m;
      return Array.isArray(m) ? "array" : m instanceof RegExp ? "object" : Ge(y, m) ? "symbol" : y;
    }
    function se(m) {
      if (typeof m > "u" || m === null)
        return "" + m;
      var y = H(m);
      if (y === "object") {
        if (m instanceof Date)
          return "date";
        if (m instanceof RegExp)
          return "regexp";
      }
      return y;
    }
    function Te(m) {
      var y = se(m);
      switch (y) {
        case "array":
        case "object":
          return "an " + y;
        case "boolean":
        case "date":
        case "regexp":
          return "a " + y;
        default:
          return y;
      }
    }
    function Xe(m) {
      return !m.constructor || !m.constructor.name ? b : m.constructor.name;
    }
    return x.checkPropTypes = a, x.resetWarningCache = a.resetWarningCache, x.PropTypes = x, x;
  }, it;
}
var ot, _n;
function Li() {
  if (_n) return ot;
  _n = 1;
  var e = /* @__PURE__ */ Yt();
  function t() {
  }
  function n() {
  }
  return n.resetWarningCache = t, ot = function() {
    function r(o, s, d, c, u, l) {
      if (l !== e) {
        var b = new Error(
          "Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types"
        );
        throw b.name = "Invariant Violation", b;
      }
    }
    r.isRequired = r;
    function a() {
      return r;
    }
    var i = {
      array: r,
      bigint: r,
      bool: r,
      func: r,
      number: r,
      object: r,
      string: r,
      symbol: r,
      any: r,
      arrayOf: a,
      element: r,
      elementType: r,
      instanceOf: a,
      node: r,
      objectOf: a,
      oneOf: a,
      oneOfType: a,
      shape: a,
      exact: a,
      checkPropTypes: n,
      resetWarningCache: t
    };
    return i.PropTypes = i, i;
  }, ot;
}
var Nn;
function ji() {
  if (Nn) return Ne.exports;
  if (Nn = 1, process.env.NODE_ENV !== "production") {
    var e = xr(), t = !0;
    Ne.exports = /* @__PURE__ */ zi()(e.isElement, t);
  } else
    Ne.exports = /* @__PURE__ */ Li()();
  return Ne.exports;
}
var Di = /* @__PURE__ */ ji();
const C = /* @__PURE__ */ vr(Di);
function In(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function G(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? In(Object(n), !0).forEach(function(r) {
      pe(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : In(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function Le(e) {
  "@babel/helpers - typeof";
  return Le = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Le(e);
}
function pe(e, t, n) {
  return t in e ? Object.defineProperty(e, t, {
    value: n,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = n, e;
}
function $i(e, t) {
  if (e == null) return {};
  var n = {}, r = Object.keys(e), a, i;
  for (i = 0; i < r.length; i++)
    a = r[i], !(t.indexOf(a) >= 0) && (n[a] = e[a]);
  return n;
}
function Ui(e, t) {
  if (e == null) return {};
  var n = $i(e, t), r, a;
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(e);
    for (a = 0; a < i.length; a++)
      r = i[a], !(t.indexOf(r) >= 0) && Object.prototype.propertyIsEnumerable.call(e, r) && (n[r] = e[r]);
  }
  return n;
}
function _t(e) {
  return Wi(e) || Yi(e) || qi(e) || Hi();
}
function Wi(e) {
  if (Array.isArray(e)) return Nt(e);
}
function Yi(e) {
  if (typeof Symbol < "u" && e[Symbol.iterator] != null || e["@@iterator"] != null) return Array.from(e);
}
function qi(e, t) {
  if (e) {
    if (typeof e == "string") return Nt(e, t);
    var n = Object.prototype.toString.call(e).slice(8, -1);
    if (n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set") return Array.from(e);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return Nt(e, t);
  }
}
function Nt(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, r = new Array(t); n < t; n++) r[n] = e[n];
  return r;
}
function Hi() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function Bi(e) {
  var t, n = e.beat, r = e.fade, a = e.beatFade, i = e.bounce, o = e.shake, s = e.flash, d = e.spin, c = e.spinPulse, u = e.spinReverse, l = e.pulse, b = e.fixedWidth, x = e.inverse, j = e.border, P = e.listItem, A = e.flip, F = e.size, U = e.rotation, k = e.pull, L = (t = {
    "fa-beat": n,
    "fa-fade": r,
    "fa-beat-fade": a,
    "fa-bounce": i,
    "fa-shake": o,
    "fa-flash": s,
    "fa-spin": d,
    "fa-spin-reverse": u,
    "fa-spin-pulse": c,
    "fa-pulse": l,
    "fa-fw": b,
    "fa-inverse": x,
    "fa-border": j,
    "fa-li": P,
    "fa-flip": A === !0,
    "fa-flip-horizontal": A === "horizontal" || A === "both",
    "fa-flip-vertical": A === "vertical" || A === "both"
  }, pe(t, "fa-".concat(F), typeof F < "u" && F !== null), pe(t, "fa-rotate-".concat(U), typeof U < "u" && U !== null && U !== 0), pe(t, "fa-pull-".concat(k), typeof k < "u" && k !== null), pe(t, "fa-swap-opacity", e.swapOpacity), t);
  return Object.keys(L).map(function(p) {
    return L[p] ? p : null;
  }).filter(function(p) {
    return p;
  });
}
function Vi(e) {
  return e = e - 0, e === e;
}
function Ar(e) {
  return Vi(e) ? e : (e = e.replace(/[\-_\s]+(.)?/g, function(t, n) {
    return n ? n.toUpperCase() : "";
  }), e.substr(0, 1).toLowerCase() + e.substr(1));
}
var Gi = ["style"];
function Xi(e) {
  return e.charAt(0).toUpperCase() + e.slice(1);
}
function Zi(e) {
  return e.split(";").map(function(t) {
    return t.trim();
  }).filter(function(t) {
    return t;
  }).reduce(function(t, n) {
    var r = n.indexOf(":"), a = Ar(n.slice(0, r)), i = n.slice(r + 1).trim();
    return a.startsWith("webkit") ? t[Xi(a)] = i : t[a] = i, t;
  }, {});
}
function Er(e, t) {
  var n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  if (typeof t == "string")
    return t;
  var r = (t.children || []).map(function(d) {
    return Er(e, d);
  }), a = Object.keys(t.attributes || {}).reduce(function(d, c) {
    var u = t.attributes[c];
    switch (c) {
      case "class":
        d.attrs.className = u, delete t.attributes.class;
        break;
      case "style":
        d.attrs.style = Zi(u);
        break;
      default:
        c.indexOf("aria-") === 0 || c.indexOf("data-") === 0 ? d.attrs[c.toLowerCase()] = u : d.attrs[Ar(c)] = u;
    }
    return d;
  }, {
    attrs: {}
  }), i = n.style, o = i === void 0 ? {} : i, s = Ui(n, Gi);
  return a.attrs.style = G(G({}, a.attrs.style), o), e.apply(void 0, [t.tag, G(G({}, a.attrs), s)].concat(_t(r)));
}
var Cr = !1;
try {
  Cr = process.env.NODE_ENV === "production";
} catch {
}
function Ki() {
  if (!Cr && console && typeof console.error == "function") {
    var e;
    (e = console).error.apply(e, arguments);
  }
}
function Fn(e) {
  if (e && Le(e) === "object" && e.prefix && e.iconName && e.icon)
    return e;
  if (kt.icon)
    return kt.icon(e);
  if (e === null)
    return null;
  if (e && Le(e) === "object" && e.prefix && e.iconName)
    return e;
  if (Array.isArray(e) && e.length === 2)
    return {
      prefix: e[0],
      iconName: e[1]
    };
  if (typeof e == "string")
    return {
      prefix: "fas",
      iconName: e
    };
}
function st(e, t) {
  return Array.isArray(t) && t.length > 0 || !Array.isArray(t) && t ? pe({}, e, t) : {};
}
var Rn = {
  border: !1,
  className: "",
  mask: null,
  maskId: null,
  fixedWidth: !1,
  inverse: !1,
  flip: !1,
  icon: null,
  listItem: !1,
  pull: null,
  pulse: !1,
  rotation: null,
  size: null,
  spin: !1,
  spinPulse: !1,
  spinReverse: !1,
  beat: !1,
  fade: !1,
  beatFade: !1,
  bounce: !1,
  shake: !1,
  symbol: !1,
  title: "",
  titleId: null,
  transform: null,
  swapOpacity: !1
}, qt = /* @__PURE__ */ je.forwardRef(function(e, t) {
  var n = G(G({}, Rn), e), r = n.icon, a = n.mask, i = n.symbol, o = n.className, s = n.title, d = n.titleId, c = n.maskId, u = Fn(r), l = st("classes", [].concat(_t(Bi(n)), _t((o || "").split(" ")))), b = st("transform", typeof n.transform == "string" ? kt.transform(n.transform) : n.transform), x = st("mask", Fn(a)), j = Ni(u, G(G(G(G({}, l), b), x), {}, {
    symbol: i,
    title: s,
    titleId: d,
    maskId: c
  }));
  if (!j)
    return Ki("Could not find icon", u), null;
  var P = j.abstract, A = {
    ref: t
  };
  return Object.keys(n).forEach(function(F) {
    Rn.hasOwnProperty(F) || (A[F] = n[F]);
  }), Ji(P[0], A);
});
qt.displayName = "FontAwesomeIcon";
qt.propTypes = {
  beat: C.bool,
  border: C.bool,
  beatFade: C.bool,
  bounce: C.bool,
  className: C.string,
  fade: C.bool,
  flash: C.bool,
  mask: C.oneOfType([C.object, C.array, C.string]),
  maskId: C.string,
  fixedWidth: C.bool,
  inverse: C.bool,
  flip: C.oneOf([!0, !1, "horizontal", "vertical", "both"]),
  icon: C.oneOfType([C.object, C.array, C.string]),
  listItem: C.bool,
  pull: C.oneOf(["right", "left"]),
  pulse: C.bool,
  rotation: C.oneOf([0, 90, 180, 270]),
  shake: C.bool,
  size: C.oneOf(["2xs", "xs", "sm", "lg", "xl", "2xl", "1x", "2x", "3x", "4x", "5x", "6x", "7x", "8x", "9x", "10x"]),
  spin: C.bool,
  spinPulse: C.bool,
  spinReverse: C.bool,
  symbol: C.oneOfType([C.bool, C.string]),
  title: C.string,
  titleId: C.string,
  transform: C.oneOfType([C.string, C.object]),
  swapOpacity: C.bool
};
var Ji = Er.bind(null, je.createElement);
function Sr(e) {
  var t, n, r = "";
  if (typeof e == "string" || typeof e == "number") r += e;
  else if (typeof e == "object") if (Array.isArray(e)) {
    var a = e.length;
    for (t = 0; t < a; t++) e[t] && (n = Sr(e[t])) && (r && (r += " "), r += n);
  } else for (n in e) e[n] && (r && (r += " "), r += n);
  return r;
}
function ne() {
  for (var e, t, n = 0, r = "", a = arguments.length; n < a; n++) (e = arguments[n]) && (t = Sr(e)) && (r && (r += " "), r += t);
  return r;
}
function _o({
  variant: e,
  size: t = "base",
  headline: n,
  constrained: r = !0,
  children: a
}) {
  const i = {
    variant: Qi(e, !!n),
    size: eo(t)
  };
  return /* @__PURE__ */ g("div", { className: "turnip", children: /* @__PURE__ */ D(
    "div",
    {
      className: ne(
        "flex w-full rounded-md border border-solid text-left",
        i.variant.container,
        i.size.container,
        r && "max-w-2xl"
      ),
      children: [
        /* @__PURE__ */ g("div", { className: ne("flex-shrink-0", i.variant.icon), children: /* @__PURE__ */ g(
          qt,
          {
            icon: to[e],
            className: i.size.icon
          }
        ) }),
        /* @__PURE__ */ D("div", { className: "-mt-px", children: [
          n && /* @__PURE__ */ g("div", { className: ne("font-bold", i.variant.headline), children: n }),
          /* @__PURE__ */ g("div", { className: ne(n && "mt-2", i.variant.body), children: a })
        ] })
      ]
    }
  ) });
}
function Qi(e, t) {
  return (
    /*tw*/
    {
      error: {
        container: "border-red-400 bg-red-50",
        icon: "text-red-600",
        headline: "text-red-900",
        body: "text-red-800"
      },
      warning: {
        container: "border-yellow-600 bg-yellow-50",
        icon: "text-yellow-600",
        headline: "text-yellow-900",
        body: t ? "text-yellow-800" : "text-yellow-900"
      },
      success: {
        container: "border-green-400 bg-green-50",
        icon: "text-green-600",
        headline: "text-green-900",
        body: "text-green-800"
      },
      info: {
        container: "border-blue-400 bg-blue-100",
        icon: "text-blue-600",
        headline: "text-blue-900",
        body: "text-blue-800"
      }
    }[e]
  );
}
function eo(e) {
  return (
    /*tw*/
    {
      sm: {
        container: "p-3.5 text-2sm/4 gap-2.5",
        icon: "text-sm"
      },
      base: {
        container: "p-4 text-sm/5 gap-3",
        icon: "text-base"
      }
    }[e]
  );
}
const to = {
  error: _r,
  warning: kr,
  success: Or,
  info: Tr
};
function No({
  ariaLabel: e,
  children: t
}) {
  return /* @__PURE__ */ g("div", { className: "turnip", children: /* @__PURE__ */ g("ul", { "aria-label": e, className: "ml-6 flex list-disc flex-col gap-1", children: t }) });
}
function no(e) {
  return `gap-${e}`;
}
function le(e, t) {
  return e == null ? "" : typeof e == "string" || typeof e == "number" || typeof e == "boolean" ? t(e) : Object.entries(e).map(([n, r]) => {
    const a = t(r);
    return n === "base" ? a : `${n}:${a}`;
  }).join(" ");
}
function lt({
  children: e,
  direction: t = "vertical",
  gap: n,
  wrap: r = !1,
  justifyContent: a = "flex-start",
  alignItems: i = "stretch"
}) {
  const o = ne(
    "flex",
    le(r, ro),
    le(t, ao),
    le(n, no),
    le(a, oo),
    le(i, lo)
  );
  return /* @__PURE__ */ g("div", { className: "turnip", children: /* @__PURE__ */ g("div", { className: o, children: e }) });
}
function ro(e) {
  return e ? "flex-wrap" : "flex-nowrap";
}
function ao(e) {
  return {
    vertical: "flex-col",
    horizontal: "flex-row"
  }[e];
}
const io = {
  "flex-start": "justify-start",
  "flex-end": "justify-end",
  center: "justify-center",
  "space-between": "justify-between",
  "space-around": "justify-around",
  "space-evenly": "justify-evenly"
};
function oo(e) {
  return io[e];
}
const so = {
  "flex-start": "items-start",
  "flex-end": "items-end",
  center: "items-center",
  baseline: "items-baseline",
  stretch: "items-stretch"
};
function lo(e) {
  return so[e];
}
function Io({
  variant: e,
  headline: t,
  children: n,
  actions: r,
  constrained: a = !0,
  error: i
}) {
  const o = co(e);
  return /* @__PURE__ */ g("div", { className: "turnip", children: /* @__PURE__ */ g(
    "div",
    {
      className: ne(
        "border border-l-8 border-solid pl-10 pr-12",
        i ? "pb-9 pt-16" : "py-16",
        a && "max-w-screen-lg",
        o
      ),
      children: /* @__PURE__ */ D(lt, { direction: "vertical", gap: 5, children: [
        /* @__PURE__ */ g("span", { className: "block text-2xl font-bold leading-none text-gray-900", children: t }),
        /* @__PURE__ */ g("div", { className: "text-base font-normal leading-6 text-gray-700", children: n }),
        /* @__PURE__ */ D(lt, { gap: 2, children: [
          /* @__PURE__ */ g(
            lt,
            {
              direction: { base: "vertical", md: "horizontal" },
              alignItems: { base: "flex-start", md: "center" },
              gap: 4,
              children: r
            }
          ),
          i && /* @__PURE__ */ g("p", { className: "text-sm text-red-700", children: i })
        ] })
      ] })
    }
  ) });
}
function co(e) {
  return (
    /*tw*/
    {
      error: "border-red-400 border-l-red-600 bg-red-50",
      warning: "border-yellow-600 border-l-yellow-600 bg-yellow-50",
      success: "border-green-400 border-l-green-600 bg-green-50",
      info: "border-blue-400 border-l-blue-600 bg-blue-100"
    }[e]
  );
}
const Ht = je.forwardRef(
  ({ to: e, ...t }, n) => /* @__PURE__ */ g("span", { className: "turnip", children: /* @__PURE__ */ g(
    "a",
    {
      ref: n,
      href: e,
      ...t,
      rel: t.target === "_blank" ? "noreferrer" : t.rel,
      onClick: t == null ? void 0 : t.onClick
    }
  ) })
);
Ht.displayName = "Link";
function fo({
  size: e = "lg",
  variant: t = "primary",
  minWidth: n = !0
} = {}) {
  return ne(
    "inline-flex select-none items-center justify-center gap-3 whitespace-nowrap border border-solid font-bold shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 disabled:opacity-50",
    uo(e),
    mo(t),
    n && "min-w-[150px]"
  );
}
function uo(e) {
  return (
    /*tw*/
    {
      xs: "rounded px-3 py-2 text-xs leading-4",
      sm: "rounded-md px-3 py-2 text-sm leading-4",
      base: "rounded-md px-4 py-2 text-sm leading-5",
      lg: "rounded-md px-4 py-2 text-base leading-6",
      xl: "rounded-md px-6 py-3 text-base leading-6"
    }[e]
  );
}
function mo(e) {
  return (
    /*tw*/
    {
      primary: "border-transparent bg-indigo-700 text-white hover:bg-indigo-800 disabled:hover:bg-indigo-700",
      secondary: "border-gray-400 bg-white text-gray-700 hover:bg-gray-100 focus:border-gray-300 disabled:hover:bg-white",
      accent: "border-transparent bg-orange-600 text-white hover:bg-orange-700 disabled:hover:bg-orange-600"
    }[e]
  );
}
const po = je.forwardRef(
  ({
    size: e = "lg",
    variant: t = "primary",
    icon: n,
    iconPlacement: r = "right",
    children: a,
    minWidth: i = !0,
    ...o
  }, s) => {
    const d = fo({ size: e, variant: t, minWidth: i }), c = /* @__PURE__ */ g(go, { icon: n, iconPlacement: r, children: a });
    return typeof o.to < "u" ? /* @__PURE__ */ g(
      Ht,
      {
        className: d,
        ...o,
        ref: s,
        children: c
      }
    ) : /* @__PURE__ */ g("span", { className: "turnip", children: /* @__PURE__ */ g(
      "button",
      {
        className: d,
        ...o,
        onClick: o == null ? void 0 : o.onClick,
        ref: s,
        children: c
      }
    ) });
  }
);
po.displayName = "Button";
function go({
  icon: e,
  iconPlacement: t,
  children: n
}) {
  return e ? /* @__PURE__ */ D(Vt, { children: [
    t === "left" && e,
    n,
    t === "right" && e
  ] }) : /* @__PURE__ */ g(Vt, { children: n });
}
const ho = "#", bo = "https://app.carrot.com/new-site/", yo = "https://app.getbeamer.com/carrot/en";
function Fo({
  sitesData: e,
  userData: t,
  userMenu: n,
  primaryNav: r,
  secondaryNav: a
}) {
  var i, o, s, d, c, u;
  return /* @__PURE__ */ g("div", { className: "turnip", children: /* @__PURE__ */ D("div", { className: "fixed left-0 right-0 top-0 z-50 w-full border-b-2 border-solid border-orange-500 text-gray-700", children: [
    /* @__PURE__ */ D("nav", { className: "z-[2] flex h-[44px] items-stretch bg-gray-100 md:h-[55px]", children: [
      /* @__PURE__ */ D("div", { className: "flex items-center", children: [
        /* @__PURE__ */ g("a", { href: ho, className: "px-1.5 text-orange-500 md:px-4", children: /* @__PURE__ */ D(
          "svg",
          {
            xmlns: "http://www.w3.org/2000/svg",
            className: "h-[27px] w-[15px] md:h-[40px] md:w-[23px]",
            viewBox: "0 0 23 40",
            fill: "none",
            children: [
              /* @__PURE__ */ g(
                "path",
                {
                  fill: "#F7931E",
                  fillRule: "evenodd",
                  d: "m15.64 31.911 1.887-1.494-3.16.06-3.918-4.408 2.942-2.01-4.2.518-4.257-4.68 4.045-2.192-4.883.98L.741 15 22.46 9.6v5.91l-4.566 2.628 4.566-.62v6.762l-2.355 1.498 2.355-.07v5.249l-1.599 1.36 1.6.125c0 4.435-.044 6.792-.13 7.07-.576.693-6.69-7.6-6.69-7.6Z",
                  clipRule: "evenodd"
                }
              ),
              /* @__PURE__ */ g(
                "path",
                {
                  fill: "#04C4AE",
                  d: "M14.054.52c.49 0-1.882 3.353-1.476 6.139 1.569-1.121 3.328-2.978 6.16-2.978 1.273 0-1.704 1.47-2.907 2.978-1.417 1.774-1.568 3.989-1.687 4.02-1.082.28-4.117 1.104-5.15 1.315-.363.074-.246-.712-.6-1.22-.356-.507-7.59-4.568-6.231-4.911 1.701-.43 4.73 1.023 6.926 1.473C9.892 3.681 12.424.52 14.054.52Z"
                }
              )
            ]
          }
        ) }),
        /* @__PURE__ */ g("div", { className: "hidden w-px self-stretch bg-gray-300 md:block" }),
        /* @__PURE__ */ D("div", { className: "flex items-center space-x-2 px-2 text-sm md:space-x-4", children: [
          /* @__PURE__ */ D("div", { className: "relative", children: [
            /* @__PURE__ */ D(
              "button",
              {
                "data-dropdown-toggle": "sitesDropdown",
                className: "flex w-[110px] items-center space-x-2 rounded-md border border-solid border-gray-300 bg-white px-3 py-1.5 text-base text-gray-900 hover:bg-gray-50 md:w-auto",
                children: [
                  /* @__PURE__ */ D("span", { className: "truncate", children: [
                    (i = e == null ? void 0 : e.currentSite) == null ? void 0 : i.name,
                    /* @__PURE__ */ g("span", { className: "text-sm text-gray-500", children: (o = e == null ? void 0 : e.currentSite) == null ? void 0 : o.url })
                  ] }),
                  V.chevronDown
                ]
              }
            ),
            /* @__PURE__ */ D(
              "div",
              {
                id: "sitesDropdown",
                className: "absolute left-0 z-50 mt-1 hidden w-64 border border-solid border-gray-300 bg-white shadow-lg",
                children: [
                  ((s = e == null ? void 0 : e.sites) == null ? void 0 : s.length) > 10 && /* @__PURE__ */ g("div", { className: "border-b border-solid border-gray-200 p-2", children: /* @__PURE__ */ g(
                    "input",
                    {
                      type: "text",
                      className: "m-0 w-full rounded border border-solid border-gray-300 px-2 py-1",
                      placeholder: "Search Sites"
                    }
                  ) }),
                  ((d = e == null ? void 0 : e.sites) == null ? void 0 : d.length) > 0 ? (c = e == null ? void 0 : e.sites) == null ? void 0 : c.map((l) => /* @__PURE__ */ D(
                    "a",
                    {
                      href: l.url,
                      className: "block px-4 py-2 hover:bg-gray-50",
                      children: [
                        /* @__PURE__ */ g("div", { className: "font-medium", children: l.name }),
                        /* @__PURE__ */ g("div", { className: "text-sm text-gray-500", children: l.domain })
                      ]
                    },
                    l.url
                  )) : /* @__PURE__ */ g(
                    "a",
                    {
                      href: bo,
                      className: "block px-4 py-2 hover:bg-gray-50",
                      children: "Add New Site"
                    }
                  )
                ]
              }
            )
          ] }),
          /* @__PURE__ */ D("div", { className: "relative", children: [
            /* @__PURE__ */ D(
              "button",
              {
                "data-dropdown-toggle": "userDropdown",
                className: "flex w-[80px] items-center space-x-2 rounded-md border border-solid border-gray-300 bg-white px-3 py-1.5 text-base text-gray-900 hover:bg-gray-50 md:w-auto",
                children: [
                  /* @__PURE__ */ g("span", { className: "truncate", children: (t == null ? void 0 : t.name) || "Select User" }),
                  V.chevronDown
                ]
              }
            ),
            /* @__PURE__ */ g(
              "div",
              {
                id: "userDropdown",
                className: "absolute left-0 z-50 mt-1 hidden w-56 border border-solid border-gray-300 bg-white shadow-lg",
                children: (u = t == null ? void 0 : t.accounts) == null ? void 0 : u.map((l) => /* @__PURE__ */ g(
                  "a",
                  {
                    href: l.href,
                    className: "block px-4 py-2 hover:bg-gray-50",
                    children: l.name
                  },
                  l.href
                ))
              }
            )
          ] })
        ] })
      ] }),
      /* @__PURE__ */ D("div", { className: "ml-auto flex items-center space-x-4 px-4", children: [
        /* @__PURE__ */ D("div", { className: "relative md:hidden", children: [
          /* @__PURE__ */ D(
            "button",
            {
              "data-dropdown-toggle": "nav-mobile-menu",
              className: "flex items-center space-x-1 text-base text-gray-900 hover:text-gray-600",
              children: [
                "More",
                /* @__PURE__ */ g("span", { className: "hidden md:block", children: V.chevronDown })
              ]
            }
          ),
          /* @__PURE__ */ g(
            "div",
            {
              id: "nav-mobile-menu",
              className: "absolute right-0 z-50 mt-1 hidden w-48 border border-solid border-gray-300 bg-white shadow-lg",
              children: r == null ? void 0 : r.map((l) => l.items ? l.items.map((b) => /* @__PURE__ */ g(
                "a",
                {
                  href: b.url,
                  className: "block px-4 py-2 hover:bg-gray-50",
                  children: b.label
                },
                b.url
              )) : /* @__PURE__ */ g(
                "a",
                {
                  href: l.url,
                  className: "block px-4 py-2 hover:bg-gray-50",
                  children: l.label
                },
                l.url
              ))
            }
          )
        ] }),
        /* @__PURE__ */ g("div", { className: "hidden items-center space-x-4 md:flex", children: r == null ? void 0 : r.map((l) => {
          var b;
          return l.items ? /* @__PURE__ */ D("div", { className: "relative", children: [
            /* @__PURE__ */ D(
              "button",
              {
                "data-dropdown-toggle": `nav-${l.label.toLowerCase()}`,
                className: "flex items-center space-x-1 text-base text-gray-900 hover:text-gray-600",
                children: [
                  /* @__PURE__ */ g("span", { children: l.label }),
                  V.chevronDown
                ]
              }
            ),
            /* @__PURE__ */ g(
              "div",
              {
                id: `nav-${l.label.toLowerCase()}`,
                className: "absolute right-0 z-50 mt-1 hidden w-48 border border-solid border-gray-300 bg-white shadow-lg",
                children: (b = l.items) == null ? void 0 : b.map((x) => /* @__PURE__ */ g(
                  "a",
                  {
                    href: x.url,
                    className: "block px-4 py-2 hover:bg-gray-50",
                    children: x.label
                  },
                  x.url
                ))
              }
            )
          ] }, l.url) : /* @__PURE__ */ g(
            "a",
            {
              href: l.url,
              className: "text-gray-900 hover:text-gray-600",
              children: l.label
            },
            l.url
          );
        }) }),
        /* @__PURE__ */ g("div", { id: "carrot-updates", children: /* @__PURE__ */ g("a", { href: yo, children: V.bell }) }),
        /* @__PURE__ */ D("div", { className: "relative", children: [
          /* @__PURE__ */ D(
            "button",
            {
              "data-dropdown-toggle": "userMenuDropdown",
              className: "flex items-center space-x-1 text-base",
              children: [
                /* @__PURE__ */ g("div", { className: "flex h-[36px] w-[36px] items-center justify-center overflow-hidden rounded-full border-2 border-solid border-orange-500 bg-gray-200", children: t != null && t.profilePic ? /* @__PURE__ */ g(
                  "img",
                  {
                    src: t.profilePic,
                    className: "h-9 w-9 rounded-full object-cover",
                    alt: t.name
                  }
                ) : /* @__PURE__ */ g("span", { className: "text-sm", children: t == null ? void 0 : t.initials }) }),
                V.chevronDown
              ]
            }
          ),
          /* @__PURE__ */ D(
            "div",
            {
              id: "userMenuDropdown",
              className: "absolute right-0 z-50 mt-1 hidden w-48 border border-solid border-gray-300 bg-white shadow-lg",
              children: [
                t && /* @__PURE__ */ D("div", { className: "border-b border-solid border-gray-300 px-4 py-2", children: [
                  /* @__PURE__ */ g("div", { className: "font-medium", children: t.name }),
                  /* @__PURE__ */ g("div", { className: "text-sm text-gray-500", children: t.role })
                ] }),
                n == null ? void 0 : n.map((l) => /* @__PURE__ */ g(
                  "a",
                  {
                    href: l.url,
                    className: "block px-4 py-2 hover:bg-gray-50",
                    children: l.label
                  },
                  l.url
                ))
              ]
            }
          )
        ] })
      ] })
    ] }),
    (a == null ? void 0 : a.length) > 0 && /* @__PURE__ */ g("nav", { className: "z-[1] flex h-[32px] w-full items-center bg-gray-200 px-4", children: /* @__PURE__ */ g("div", { className: "flex items-center space-x-5 text-sm", children: a == null ? void 0 : a.map((l) => /* @__PURE__ */ D(
      "a",
      {
        href: l.url,
        className: "flex items-center text-sm text-gray-700 hover:text-gray-900",
        ...l.attributes,
        children: [
          l.label === "Edit" ? /* @__PURE__ */ g("span", { className: "mr-1 flex h-3 w-3 items-center justify-center", children: V.edit }) : l.label === "Design" ? /* @__PURE__ */ g("span", { className: "mr-1 flex h-3 w-3 items-center justify-center", children: V.design }) : l.label === "SEO" ? /* @__PURE__ */ g("span", { className: "mr-1 flex h-3 w-3 items-center justify-center", children: V.seo }) : l.label === "New" ? /* @__PURE__ */ g("span", { className: "mr-1 flex h-3 w-3 items-center justify-center", children: V.new }) : l.icon && /* @__PURE__ */ g("span", { className: "mr-1 flex h-3 w-3 items-center justify-center", children: l.icon }),
          l.label
        ]
      },
      l.url
    )) }) })
  ] }) });
}
const V = {
  chevronDown: /* @__PURE__ */ g("svg", { xmlns: "http://www.w3.org/2000/svg", width: "12", height: "12", fill: "none", children: /* @__PURE__ */ g(
    "path",
    {
      fill: "#0F172A",
      d: "M5.46 8.04 1.71 4.29a.723.723 0 0 1 0-1.056.723.723 0 0 1 1.056 0L6 6.445l3.21-3.21a.723.723 0 0 1 1.056 0 .723.723 0 0 1 0 1.054l-3.75 3.75a.723.723 0 0 1-1.055 0Z"
    }
  ) }),
  bell: /* @__PURE__ */ g("svg", { xmlns: "http://www.w3.org/2000/svg", width: "14", height: "20", fill: "none", children: /* @__PURE__ */ g(
    "path",
    {
      fill: "#0F172A",
      d: "M7 2c-.531 0-1 .469-1 1v.563c-2.25.374-4 2.343-4 4.687v1.063a6.362 6.362 0 0 1-1.344 3.906l-.469.562a.776.776 0 0 0-.093.813c.125.25.375.406.656.406h12.5a.742.742 0 0 0 .688-.406.776.776 0 0 0-.094-.813l-.469-.562C12.5 12.094 12 10.719 12 9.313V8.25c0-2.344-1.719-4.313-4-4.688V3c0-.531-.438-1-1-1Zm0 3h.25a3.247 3.247 0 0 1 3.25 3.25v1.063c0 1.5.438 2.937 1.25 4.187H2.281C3.094 12.25 3.5 10.812 3.5 9.312V8.25A3.268 3.268 0 0 1 6.75 5H7ZM5 16c0 .531.219 1.063.594 1.438S6.469 18 7 18c.531 0 1.063-.188 1.438-.563C8.812 17.063 9 16.532 9 16H5Z"
    }
  ) }),
  design: /* @__PURE__ */ g("svg", { xmlns: "http://www.w3.org/2000/svg", width: "13", height: "13", fill: "none", children: /* @__PURE__ */ g(
    "path",
    {
      fill: "#0F172A",
      d: "m5.766 6.156 1.828 1.828 3.937-5.25c.117-.14.094-.351-.023-.492-.14-.117-.352-.14-.492-.023l-5.25 3.937Zm-1.852 2.39a1.809 1.809 0 0 0-.352-.046c-.937 0-1.687.773-1.687 1.688v.28c.094.493-.047 1.009-.305 1.407h-.023 2.016c.914 0 1.687-.75 1.687-1.688 0-.117-.023-.234-.047-.351l-1.289-1.29Zm4.336.47c-.469.586-1.148.96-1.898.984 0 .07.023.14.023.188A2.806 2.806 0 0 1 3.562 13H0a.74.74 0 0 1-.75-.75c0-.398.328-.75.75-.75h.14c.422 0 .704-.445.633-.867-.023-.14-.023-.281-.023-.445a2.806 2.806 0 0 1 2.813-2.813c.046 0 .117.023.187.023.023-.75.398-1.43.984-1.898l5.602-4.195a1.528 1.528 0 0 1 1.969.14c.515.54.586 1.36.14 1.97l-4.195 5.6Z"
    }
  ) }),
  edit: /* @__PURE__ */ g(
    "svg",
    {
      width: "14",
      height: "14",
      viewBox: "0 0 14 14",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: /* @__PURE__ */ g(
        "path",
        {
          d: "M1.84375 9.46094C1.9375 9.13281 2.125 8.82812 2.35938 8.59375L9.48438 1.46875C10.0703 0.882812 11.0312 0.882812 11.6172 1.46875L12.5312 2.38281C12.6016 2.45312 12.6719 2.54688 12.7188 2.61719C13.1172 3.20312 13.0469 4 12.5312 4.51562L5.40625 11.6406C5.38281 11.6641 5.33594 11.6875 5.3125 11.7344C5.07812 11.9219 4.82031 12.0625 4.53906 12.1562L2.71094 12.6953L1.70312 13C1.51562 13.0469 1.30469 13 1.16406 12.8359C1 12.6953 0.953125 12.4844 1.02344 12.2969L1.30469 11.2891L1.84375 9.46094ZM2.92188 9.78906L2.75781 10.3281L2.38281 11.6172L3.67188 11.2422L4.21094 11.0781C4.375 11.0312 4.49219 10.9609 4.60938 10.8438L9.97656 5.47656L8.52344 4.02344L3.15625 9.39062C3.13281 9.39062 3.13281 9.41406 3.10938 9.4375C3.01562 9.53125 2.96875 9.64844 2.92188 9.78906Z",
          fill: "#0F172A"
        }
      )
    }
  ),
  new: /* @__PURE__ */ g("svg", { xmlns: "http://www.w3.org/2000/svg", width: "12", height: "12", fill: "none", children: /* @__PURE__ */ g(
    "path",
    {
      fill: "#0F172A",
      d: "M6.563 1.688v3.75h3.75a.57.57 0 0 1 .562.562.555.555 0 0 1-.563.563h-3.75v3.75a.555.555 0 0 1-.562.562.542.542 0 0 1-.563-.563v-3.75h-3.75A.542.542 0 0 1 1.125 6c0-.305.234-.563.563-.563h3.75v-3.75c0-.304.234-.562.562-.562a.57.57 0 0 1 .563.563Z"
    }
  ) }),
  seo: /* @__PURE__ */ g("svg", { xmlns: "http://www.w3.org/2000/svg", width: "12", height: "12", fill: "none", children: /* @__PURE__ */ g(
    "path",
    {
      fill: "#0F172A",
      d: "M.563.75a.57.57 0 0 1 .562.563v8.25c0 .328.234.562.563.562h9.75a.57.57 0 0 1 .562.563.555.555 0 0 1-.563.562h-9.75A1.68 1.68 0 0 1 0 9.562v-8.25C0 1.008.234.75.563.75Zm3.375 4.5a.57.57 0 0 1 .562.563v1.875a.555.555 0 0 1-.563.562.542.542 0 0 1-.562-.563V5.813c0-.304.234-.562.563-.562ZM6.75 3.562v4.126a.555.555 0 0 1-.563.562.542.542 0 0 1-.562-.563V3.563c0-.304.234-.562.563-.562a.57.57 0 0 1 .562.563Zm1.688.938A.57.57 0 0 1 9 5.063v2.625a.555.555 0 0 1-.563.562.542.542 0 0 1-.562-.563V5.063c0-.304.234-.562.563-.562Zm2.812-2.438v5.626a.555.555 0 0 1-.563.562.542.542 0 0 1-.562-.563V2.063c0-.304.234-.562.563-.562a.57.57 0 0 1 .562.563Z"
    }
  ) })
};
function Ro({ top: e = 0, left: t = 0, children: n }) {
  const r = le(e, vo), a = le(
    t,
    xo
  );
  return /* @__PURE__ */ g("div", { className: "turnip", children: /* @__PURE__ */ g("div", { className: `${r} ${a}`, children: n }) });
}
function vo(e) {
  return `mt-${e}`;
}
function xo(e) {
  return `ml-${e}`;
}
const wo = ({
  variant: e = "strong",
  display: t = "inline",
  size: n
}) => ne(
  `${t} items-center rounded-sm focus-visible:outline-none focus-visible:ring-2`,
  e !== "contextual" && "text-indigo-700 hover:text-indigo-800 focus-visible:ring-blue-500",
  e === "strong" && "font-bold",
  e === "underlined" && "underline",
  e === "plain" && "hover:underline",
  e === "contextual" && "font-bold text-inherit underline focus-visible:ring-current",
  n
);
function Mo({
  children: e,
  className: t,
  variant: n,
  display: r = "inline",
  size: a,
  ...i
}) {
  return /* @__PURE__ */ g(Ht, { className: wo({ variant: n, size: a, display: r }), ...i, children: e });
}
const Ao = {
  transparent: "transparent",
  current: "currentColor",
  inherit: "inherit",
  black: "#000",
  white: "#fff",
  investorfuse: {
    primary: "#3780b8",
    secondary: "#0FB46D"
  },
  gray: {
    50: "#f8fafc",
    100: "#f1f5f9",
    200: "#e2e8f0",
    300: "#cbd5e1",
    400: "#94a3b8",
    500: "#64748b",
    600: "#475569",
    700: "#334155",
    800: "#1e293b",
    900: "#0f172a",
    950: "#020204"
  },
  orange: {
    50: "#FFFCF9",
    100: "#FFF7ED",
    200: "#FDEAD2",
    300: "#fcd2a1",
    400: "#f9ab4f",
    500: "#f7931e",
    600: "#E87211",
    700: "#c05621",
    800: "#9c4221",
    900: "#7b341e",
    950: "#441D11"
  },
  red: {
    50: "#fef2f2",
    100: "#fee2e2",
    200: "#fecaca",
    300: "#fca5a5",
    400: "#f87171",
    500: "#ef4444",
    600: "#dc2626",
    700: "#b91c1c",
    800: "#991b1b",
    900: "#7f1d1d",
    950: "#481010"
  },
  yellow: {
    50: "#FFFEF1",
    100: "#fffae1",
    200: "#fff4bf",
    300: "#feec8d",
    400: "#fee66b",
    500: "#FEE049",
    600: "#f1c901",
    700: "#cfad01",
    800: "#877201",
    900: "#594a00",
    950: "#372e00"
  },
  green: {
    50: "#f0fdf4",
    100: "#DCFCE7",
    200: "#c6f6d5",
    300: "#9ae6b4",
    400: "#68d391",
    500: "#48bb78",
    600: "#38a169",
    700: "#2f855a",
    800: "#276749",
    900: "#22543d",
    950: "#0E241A"
  },
  teal: {
    50: "#f0fdfa",
    100: "#e6fffa",
    200: "#b2f5ea",
    300: "#81e6d9",
    400: "#04d5bd",
    500: "#04C4AE",
    600: "#319795",
    700: "#2c7a7b",
    800: "#285e61",
    900: "#234e52",
    950: "#0F2122"
  },
  blue: {
    50: "#F6FCFF",
    100: "#ebf8ff",
    200: "#bee3f8",
    300: "#90cdf4",
    400: "#63b3ed",
    500: "#4299e1",
    600: "#3182ce",
    700: "#2b6cb0",
    800: "#2c5282",
    900: "#2a4365",
    950: "#111B29"
  },
  indigo: {
    50: "#F1F7FD",
    100: "#ebf4ff",
    200: "#c3dafe",
    300: "#a3bffa",
    400: "#7f9cf5",
    500: "#577CFE",
    600: "#4659FC",
    700: "#3141CE",
    800: "#243097",
    900: "#141a53",
    950: "#0a0d2a"
  },
  purple: {
    50: "#faf5ff",
    100: "#f3e8ff",
    200: "#e5b5f8",
    300: "#cb67f1",
    400: "#b529eb",
    500: "#9A13CE",
    600: "#8310af",
    700: "#6c0d90",
    800: "#540a71",
    900: "#260533",
    950: "#1a0324"
  },
  pink: {
    50: "#FDF2F8",
    100: "#FCE7F3",
    200: "#fed7e2",
    300: "#fbb6ce",
    400: "#f687b3",
    500: "#ed64a6",
    600: "#d53f8c",
    700: "#b83280",
    800: "#97266d",
    900: "#702459",
    950: "#3d1330"
  }
};
var ct = {}, ft = {}, Mn;
function Eo() {
  return Mn || (Mn = 1, function(e) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), Object.defineProperty(e, "cloneDeep", {
      enumerable: !0,
      get: function() {
        return t;
      }
    });
    function t(n) {
      return Array.isArray(n) ? n.map((r) => t(r)) : typeof n == "object" && n !== null ? Object.fromEntries(Object.entries(n).map(([r, a]) => [
        r,
        t(a)
      ])) : n;
    }
  }(ft)), ft;
}
var ut, zn;
function Co() {
  return zn || (zn = 1, ut = {
    content: [],
    presets: [],
    darkMode: "media",
    // or 'class'
    theme: {
      accentColor: ({ theme: e }) => ({
        ...e("colors"),
        auto: "auto"
      }),
      animation: {
        none: "none",
        spin: "spin 1s linear infinite",
        ping: "ping 1s cubic-bezier(0, 0, 0.2, 1) infinite",
        pulse: "pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite",
        bounce: "bounce 1s infinite"
      },
      aria: {
        busy: 'busy="true"',
        checked: 'checked="true"',
        disabled: 'disabled="true"',
        expanded: 'expanded="true"',
        hidden: 'hidden="true"',
        pressed: 'pressed="true"',
        readonly: 'readonly="true"',
        required: 'required="true"',
        selected: 'selected="true"'
      },
      aspectRatio: {
        auto: "auto",
        square: "1 / 1",
        video: "16 / 9"
      },
      backdropBlur: ({ theme: e }) => e("blur"),
      backdropBrightness: ({ theme: e }) => e("brightness"),
      backdropContrast: ({ theme: e }) => e("contrast"),
      backdropGrayscale: ({ theme: e }) => e("grayscale"),
      backdropHueRotate: ({ theme: e }) => e("hueRotate"),
      backdropInvert: ({ theme: e }) => e("invert"),
      backdropOpacity: ({ theme: e }) => e("opacity"),
      backdropSaturate: ({ theme: e }) => e("saturate"),
      backdropSepia: ({ theme: e }) => e("sepia"),
      backgroundColor: ({ theme: e }) => e("colors"),
      backgroundImage: {
        none: "none",
        "gradient-to-t": "linear-gradient(to top, var(--tw-gradient-stops))",
        "gradient-to-tr": "linear-gradient(to top right, var(--tw-gradient-stops))",
        "gradient-to-r": "linear-gradient(to right, var(--tw-gradient-stops))",
        "gradient-to-br": "linear-gradient(to bottom right, var(--tw-gradient-stops))",
        "gradient-to-b": "linear-gradient(to bottom, var(--tw-gradient-stops))",
        "gradient-to-bl": "linear-gradient(to bottom left, var(--tw-gradient-stops))",
        "gradient-to-l": "linear-gradient(to left, var(--tw-gradient-stops))",
        "gradient-to-tl": "linear-gradient(to top left, var(--tw-gradient-stops))"
      },
      backgroundOpacity: ({ theme: e }) => e("opacity"),
      backgroundPosition: {
        bottom: "bottom",
        center: "center",
        left: "left",
        "left-bottom": "left bottom",
        "left-top": "left top",
        right: "right",
        "right-bottom": "right bottom",
        "right-top": "right top",
        top: "top"
      },
      backgroundSize: {
        auto: "auto",
        cover: "cover",
        contain: "contain"
      },
      blur: {
        0: "0",
        none: "",
        sm: "4px",
        DEFAULT: "8px",
        md: "12px",
        lg: "16px",
        xl: "24px",
        "2xl": "40px",
        "3xl": "64px"
      },
      borderColor: ({ theme: e }) => ({
        ...e("colors"),
        DEFAULT: e("colors.gray.200", "currentColor")
      }),
      borderOpacity: ({ theme: e }) => e("opacity"),
      borderRadius: {
        none: "0px",
        sm: "0.125rem",
        DEFAULT: "0.25rem",
        md: "0.375rem",
        lg: "0.5rem",
        xl: "0.75rem",
        "2xl": "1rem",
        "3xl": "1.5rem",
        full: "9999px"
      },
      borderSpacing: ({ theme: e }) => ({
        ...e("spacing")
      }),
      borderWidth: {
        DEFAULT: "1px",
        0: "0px",
        2: "2px",
        4: "4px",
        8: "8px"
      },
      boxShadow: {
        sm: "0 1px 2px 0 rgb(0 0 0 / 0.05)",
        DEFAULT: "0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1)",
        md: "0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1)",
        lg: "0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1)",
        xl: "0 20px 25px -5px rgb(0 0 0 / 0.1), 0 8px 10px -6px rgb(0 0 0 / 0.1)",
        "2xl": "0 25px 50px -12px rgb(0 0 0 / 0.25)",
        inner: "inset 0 2px 4px 0 rgb(0 0 0 / 0.05)",
        none: "none"
      },
      boxShadowColor: ({ theme: e }) => e("colors"),
      brightness: {
        0: "0",
        50: ".5",
        75: ".75",
        90: ".9",
        95: ".95",
        100: "1",
        105: "1.05",
        110: "1.1",
        125: "1.25",
        150: "1.5",
        200: "2"
      },
      caretColor: ({ theme: e }) => e("colors"),
      colors: ({ colors: e }) => ({
        inherit: e.inherit,
        current: e.current,
        transparent: e.transparent,
        black: e.black,
        white: e.white,
        slate: e.slate,
        gray: e.gray,
        zinc: e.zinc,
        neutral: e.neutral,
        stone: e.stone,
        red: e.red,
        orange: e.orange,
        amber: e.amber,
        yellow: e.yellow,
        lime: e.lime,
        green: e.green,
        emerald: e.emerald,
        teal: e.teal,
        cyan: e.cyan,
        sky: e.sky,
        blue: e.blue,
        indigo: e.indigo,
        violet: e.violet,
        purple: e.purple,
        fuchsia: e.fuchsia,
        pink: e.pink,
        rose: e.rose
      }),
      columns: {
        auto: "auto",
        1: "1",
        2: "2",
        3: "3",
        4: "4",
        5: "5",
        6: "6",
        7: "7",
        8: "8",
        9: "9",
        10: "10",
        11: "11",
        12: "12",
        "3xs": "16rem",
        "2xs": "18rem",
        xs: "20rem",
        sm: "24rem",
        md: "28rem",
        lg: "32rem",
        xl: "36rem",
        "2xl": "42rem",
        "3xl": "48rem",
        "4xl": "56rem",
        "5xl": "64rem",
        "6xl": "72rem",
        "7xl": "80rem"
      },
      container: {},
      content: {
        none: "none"
      },
      contrast: {
        0: "0",
        50: ".5",
        75: ".75",
        100: "1",
        125: "1.25",
        150: "1.5",
        200: "2"
      },
      cursor: {
        auto: "auto",
        default: "default",
        pointer: "pointer",
        wait: "wait",
        text: "text",
        move: "move",
        help: "help",
        "not-allowed": "not-allowed",
        none: "none",
        "context-menu": "context-menu",
        progress: "progress",
        cell: "cell",
        crosshair: "crosshair",
        "vertical-text": "vertical-text",
        alias: "alias",
        copy: "copy",
        "no-drop": "no-drop",
        grab: "grab",
        grabbing: "grabbing",
        "all-scroll": "all-scroll",
        "col-resize": "col-resize",
        "row-resize": "row-resize",
        "n-resize": "n-resize",
        "e-resize": "e-resize",
        "s-resize": "s-resize",
        "w-resize": "w-resize",
        "ne-resize": "ne-resize",
        "nw-resize": "nw-resize",
        "se-resize": "se-resize",
        "sw-resize": "sw-resize",
        "ew-resize": "ew-resize",
        "ns-resize": "ns-resize",
        "nesw-resize": "nesw-resize",
        "nwse-resize": "nwse-resize",
        "zoom-in": "zoom-in",
        "zoom-out": "zoom-out"
      },
      divideColor: ({ theme: e }) => e("borderColor"),
      divideOpacity: ({ theme: e }) => e("borderOpacity"),
      divideWidth: ({ theme: e }) => e("borderWidth"),
      dropShadow: {
        sm: "0 1px 1px rgb(0 0 0 / 0.05)",
        DEFAULT: ["0 1px 2px rgb(0 0 0 / 0.1)", "0 1px 1px rgb(0 0 0 / 0.06)"],
        md: ["0 4px 3px rgb(0 0 0 / 0.07)", "0 2px 2px rgb(0 0 0 / 0.06)"],
        lg: ["0 10px 8px rgb(0 0 0 / 0.04)", "0 4px 3px rgb(0 0 0 / 0.1)"],
        xl: ["0 20px 13px rgb(0 0 0 / 0.03)", "0 8px 5px rgb(0 0 0 / 0.08)"],
        "2xl": "0 25px 25px rgb(0 0 0 / 0.15)",
        none: "0 0 #0000"
      },
      fill: ({ theme: e }) => ({
        none: "none",
        ...e("colors")
      }),
      flex: {
        1: "1 1 0%",
        auto: "1 1 auto",
        initial: "0 1 auto",
        none: "none"
      },
      flexBasis: ({ theme: e }) => ({
        auto: "auto",
        ...e("spacing"),
        "1/2": "50%",
        "1/3": "33.333333%",
        "2/3": "66.666667%",
        "1/4": "25%",
        "2/4": "50%",
        "3/4": "75%",
        "1/5": "20%",
        "2/5": "40%",
        "3/5": "60%",
        "4/5": "80%",
        "1/6": "16.666667%",
        "2/6": "33.333333%",
        "3/6": "50%",
        "4/6": "66.666667%",
        "5/6": "83.333333%",
        "1/12": "8.333333%",
        "2/12": "16.666667%",
        "3/12": "25%",
        "4/12": "33.333333%",
        "5/12": "41.666667%",
        "6/12": "50%",
        "7/12": "58.333333%",
        "8/12": "66.666667%",
        "9/12": "75%",
        "10/12": "83.333333%",
        "11/12": "91.666667%",
        full: "100%"
      }),
      flexGrow: {
        0: "0",
        DEFAULT: "1"
      },
      flexShrink: {
        0: "0",
        DEFAULT: "1"
      },
      fontFamily: {
        sans: [
          "ui-sans-serif",
          "system-ui",
          "sans-serif",
          '"Apple Color Emoji"',
          '"Segoe UI Emoji"',
          '"Segoe UI Symbol"',
          '"Noto Color Emoji"'
        ],
        serif: ["ui-serif", "Georgia", "Cambria", '"Times New Roman"', "Times", "serif"],
        mono: [
          "ui-monospace",
          "SFMono-Regular",
          "Menlo",
          "Monaco",
          "Consolas",
          '"Liberation Mono"',
          '"Courier New"',
          "monospace"
        ]
      },
      fontSize: {
        xs: ["0.75rem", { lineHeight: "1rem" }],
        sm: ["0.875rem", { lineHeight: "1.25rem" }],
        base: ["1rem", { lineHeight: "1.5rem" }],
        lg: ["1.125rem", { lineHeight: "1.75rem" }],
        xl: ["1.25rem", { lineHeight: "1.75rem" }],
        "2xl": ["1.5rem", { lineHeight: "2rem" }],
        "3xl": ["1.875rem", { lineHeight: "2.25rem" }],
        "4xl": ["2.25rem", { lineHeight: "2.5rem" }],
        "5xl": ["3rem", { lineHeight: "1" }],
        "6xl": ["3.75rem", { lineHeight: "1" }],
        "7xl": ["4.5rem", { lineHeight: "1" }],
        "8xl": ["6rem", { lineHeight: "1" }],
        "9xl": ["8rem", { lineHeight: "1" }]
      },
      fontWeight: {
        thin: "100",
        extralight: "200",
        light: "300",
        normal: "400",
        medium: "500",
        semibold: "600",
        bold: "700",
        extrabold: "800",
        black: "900"
      },
      gap: ({ theme: e }) => e("spacing"),
      gradientColorStops: ({ theme: e }) => e("colors"),
      gradientColorStopPositions: {
        "0%": "0%",
        "5%": "5%",
        "10%": "10%",
        "15%": "15%",
        "20%": "20%",
        "25%": "25%",
        "30%": "30%",
        "35%": "35%",
        "40%": "40%",
        "45%": "45%",
        "50%": "50%",
        "55%": "55%",
        "60%": "60%",
        "65%": "65%",
        "70%": "70%",
        "75%": "75%",
        "80%": "80%",
        "85%": "85%",
        "90%": "90%",
        "95%": "95%",
        "100%": "100%"
      },
      grayscale: {
        0: "0",
        DEFAULT: "100%"
      },
      gridAutoColumns: {
        auto: "auto",
        min: "min-content",
        max: "max-content",
        fr: "minmax(0, 1fr)"
      },
      gridAutoRows: {
        auto: "auto",
        min: "min-content",
        max: "max-content",
        fr: "minmax(0, 1fr)"
      },
      gridColumn: {
        auto: "auto",
        "span-1": "span 1 / span 1",
        "span-2": "span 2 / span 2",
        "span-3": "span 3 / span 3",
        "span-4": "span 4 / span 4",
        "span-5": "span 5 / span 5",
        "span-6": "span 6 / span 6",
        "span-7": "span 7 / span 7",
        "span-8": "span 8 / span 8",
        "span-9": "span 9 / span 9",
        "span-10": "span 10 / span 10",
        "span-11": "span 11 / span 11",
        "span-12": "span 12 / span 12",
        "span-full": "1 / -1"
      },
      gridColumnEnd: {
        auto: "auto",
        1: "1",
        2: "2",
        3: "3",
        4: "4",
        5: "5",
        6: "6",
        7: "7",
        8: "8",
        9: "9",
        10: "10",
        11: "11",
        12: "12",
        13: "13"
      },
      gridColumnStart: {
        auto: "auto",
        1: "1",
        2: "2",
        3: "3",
        4: "4",
        5: "5",
        6: "6",
        7: "7",
        8: "8",
        9: "9",
        10: "10",
        11: "11",
        12: "12",
        13: "13"
      },
      gridRow: {
        auto: "auto",
        "span-1": "span 1 / span 1",
        "span-2": "span 2 / span 2",
        "span-3": "span 3 / span 3",
        "span-4": "span 4 / span 4",
        "span-5": "span 5 / span 5",
        "span-6": "span 6 / span 6",
        "span-7": "span 7 / span 7",
        "span-8": "span 8 / span 8",
        "span-9": "span 9 / span 9",
        "span-10": "span 10 / span 10",
        "span-11": "span 11 / span 11",
        "span-12": "span 12 / span 12",
        "span-full": "1 / -1"
      },
      gridRowEnd: {
        auto: "auto",
        1: "1",
        2: "2",
        3: "3",
        4: "4",
        5: "5",
        6: "6",
        7: "7",
        8: "8",
        9: "9",
        10: "10",
        11: "11",
        12: "12",
        13: "13"
      },
      gridRowStart: {
        auto: "auto",
        1: "1",
        2: "2",
        3: "3",
        4: "4",
        5: "5",
        6: "6",
        7: "7",
        8: "8",
        9: "9",
        10: "10",
        11: "11",
        12: "12",
        13: "13"
      },
      gridTemplateColumns: {
        none: "none",
        subgrid: "subgrid",
        1: "repeat(1, minmax(0, 1fr))",
        2: "repeat(2, minmax(0, 1fr))",
        3: "repeat(3, minmax(0, 1fr))",
        4: "repeat(4, minmax(0, 1fr))",
        5: "repeat(5, minmax(0, 1fr))",
        6: "repeat(6, minmax(0, 1fr))",
        7: "repeat(7, minmax(0, 1fr))",
        8: "repeat(8, minmax(0, 1fr))",
        9: "repeat(9, minmax(0, 1fr))",
        10: "repeat(10, minmax(0, 1fr))",
        11: "repeat(11, minmax(0, 1fr))",
        12: "repeat(12, minmax(0, 1fr))"
      },
      gridTemplateRows: {
        none: "none",
        subgrid: "subgrid",
        1: "repeat(1, minmax(0, 1fr))",
        2: "repeat(2, minmax(0, 1fr))",
        3: "repeat(3, minmax(0, 1fr))",
        4: "repeat(4, minmax(0, 1fr))",
        5: "repeat(5, minmax(0, 1fr))",
        6: "repeat(6, minmax(0, 1fr))",
        7: "repeat(7, minmax(0, 1fr))",
        8: "repeat(8, minmax(0, 1fr))",
        9: "repeat(9, minmax(0, 1fr))",
        10: "repeat(10, minmax(0, 1fr))",
        11: "repeat(11, minmax(0, 1fr))",
        12: "repeat(12, minmax(0, 1fr))"
      },
      height: ({ theme: e }) => ({
        auto: "auto",
        ...e("spacing"),
        "1/2": "50%",
        "1/3": "33.333333%",
        "2/3": "66.666667%",
        "1/4": "25%",
        "2/4": "50%",
        "3/4": "75%",
        "1/5": "20%",
        "2/5": "40%",
        "3/5": "60%",
        "4/5": "80%",
        "1/6": "16.666667%",
        "2/6": "33.333333%",
        "3/6": "50%",
        "4/6": "66.666667%",
        "5/6": "83.333333%",
        full: "100%",
        screen: "100vh",
        svh: "100svh",
        lvh: "100lvh",
        dvh: "100dvh",
        min: "min-content",
        max: "max-content",
        fit: "fit-content"
      }),
      hueRotate: {
        0: "0deg",
        15: "15deg",
        30: "30deg",
        60: "60deg",
        90: "90deg",
        180: "180deg"
      },
      inset: ({ theme: e }) => ({
        auto: "auto",
        ...e("spacing"),
        "1/2": "50%",
        "1/3": "33.333333%",
        "2/3": "66.666667%",
        "1/4": "25%",
        "2/4": "50%",
        "3/4": "75%",
        full: "100%"
      }),
      invert: {
        0: "0",
        DEFAULT: "100%"
      },
      keyframes: {
        spin: {
          to: {
            transform: "rotate(360deg)"
          }
        },
        ping: {
          "75%, 100%": {
            transform: "scale(2)",
            opacity: "0"
          }
        },
        pulse: {
          "50%": {
            opacity: ".5"
          }
        },
        bounce: {
          "0%, 100%": {
            transform: "translateY(-25%)",
            animationTimingFunction: "cubic-bezier(0.8,0,1,1)"
          },
          "50%": {
            transform: "none",
            animationTimingFunction: "cubic-bezier(0,0,0.2,1)"
          }
        }
      },
      letterSpacing: {
        tighter: "-0.05em",
        tight: "-0.025em",
        normal: "0em",
        wide: "0.025em",
        wider: "0.05em",
        widest: "0.1em"
      },
      lineHeight: {
        none: "1",
        tight: "1.25",
        snug: "1.375",
        normal: "1.5",
        relaxed: "1.625",
        loose: "2",
        3: ".75rem",
        4: "1rem",
        5: "1.25rem",
        6: "1.5rem",
        7: "1.75rem",
        8: "2rem",
        9: "2.25rem",
        10: "2.5rem"
      },
      listStyleType: {
        none: "none",
        disc: "disc",
        decimal: "decimal"
      },
      listStyleImage: {
        none: "none"
      },
      margin: ({ theme: e }) => ({
        auto: "auto",
        ...e("spacing")
      }),
      lineClamp: {
        1: "1",
        2: "2",
        3: "3",
        4: "4",
        5: "5",
        6: "6"
      },
      maxHeight: ({ theme: e }) => ({
        ...e("spacing"),
        none: "none",
        full: "100%",
        screen: "100vh",
        svh: "100svh",
        lvh: "100lvh",
        dvh: "100dvh",
        min: "min-content",
        max: "max-content",
        fit: "fit-content"
      }),
      maxWidth: ({ theme: e, breakpoints: t }) => ({
        ...e("spacing"),
        none: "none",
        xs: "20rem",
        sm: "24rem",
        md: "28rem",
        lg: "32rem",
        xl: "36rem",
        "2xl": "42rem",
        "3xl": "48rem",
        "4xl": "56rem",
        "5xl": "64rem",
        "6xl": "72rem",
        "7xl": "80rem",
        full: "100%",
        min: "min-content",
        max: "max-content",
        fit: "fit-content",
        prose: "65ch",
        ...t(e("screens"))
      }),
      minHeight: ({ theme: e }) => ({
        ...e("spacing"),
        full: "100%",
        screen: "100vh",
        svh: "100svh",
        lvh: "100lvh",
        dvh: "100dvh",
        min: "min-content",
        max: "max-content",
        fit: "fit-content"
      }),
      minWidth: ({ theme: e }) => ({
        ...e("spacing"),
        full: "100%",
        min: "min-content",
        max: "max-content",
        fit: "fit-content"
      }),
      objectPosition: {
        bottom: "bottom",
        center: "center",
        left: "left",
        "left-bottom": "left bottom",
        "left-top": "left top",
        right: "right",
        "right-bottom": "right bottom",
        "right-top": "right top",
        top: "top"
      },
      opacity: {
        0: "0",
        5: "0.05",
        10: "0.1",
        15: "0.15",
        20: "0.2",
        25: "0.25",
        30: "0.3",
        35: "0.35",
        40: "0.4",
        45: "0.45",
        50: "0.5",
        55: "0.55",
        60: "0.6",
        65: "0.65",
        70: "0.7",
        75: "0.75",
        80: "0.8",
        85: "0.85",
        90: "0.9",
        95: "0.95",
        100: "1"
      },
      order: {
        first: "-9999",
        last: "9999",
        none: "0",
        1: "1",
        2: "2",
        3: "3",
        4: "4",
        5: "5",
        6: "6",
        7: "7",
        8: "8",
        9: "9",
        10: "10",
        11: "11",
        12: "12"
      },
      outlineColor: ({ theme: e }) => e("colors"),
      outlineOffset: {
        0: "0px",
        1: "1px",
        2: "2px",
        4: "4px",
        8: "8px"
      },
      outlineWidth: {
        0: "0px",
        1: "1px",
        2: "2px",
        4: "4px",
        8: "8px"
      },
      padding: ({ theme: e }) => e("spacing"),
      placeholderColor: ({ theme: e }) => e("colors"),
      placeholderOpacity: ({ theme: e }) => e("opacity"),
      ringColor: ({ theme: e }) => ({
        DEFAULT: e("colors.blue.500", "#3b82f6"),
        ...e("colors")
      }),
      ringOffsetColor: ({ theme: e }) => e("colors"),
      ringOffsetWidth: {
        0: "0px",
        1: "1px",
        2: "2px",
        4: "4px",
        8: "8px"
      },
      ringOpacity: ({ theme: e }) => ({
        DEFAULT: "0.5",
        ...e("opacity")
      }),
      ringWidth: {
        DEFAULT: "3px",
        0: "0px",
        1: "1px",
        2: "2px",
        4: "4px",
        8: "8px"
      },
      rotate: {
        0: "0deg",
        1: "1deg",
        2: "2deg",
        3: "3deg",
        6: "6deg",
        12: "12deg",
        45: "45deg",
        90: "90deg",
        180: "180deg"
      },
      saturate: {
        0: "0",
        50: ".5",
        100: "1",
        150: "1.5",
        200: "2"
      },
      scale: {
        0: "0",
        50: ".5",
        75: ".75",
        90: ".9",
        95: ".95",
        100: "1",
        105: "1.05",
        110: "1.1",
        125: "1.25",
        150: "1.5"
      },
      screens: {
        sm: "640px",
        md: "768px",
        lg: "1024px",
        xl: "1280px",
        "2xl": "1536px"
      },
      scrollMargin: ({ theme: e }) => ({
        ...e("spacing")
      }),
      scrollPadding: ({ theme: e }) => e("spacing"),
      sepia: {
        0: "0",
        DEFAULT: "100%"
      },
      skew: {
        0: "0deg",
        1: "1deg",
        2: "2deg",
        3: "3deg",
        6: "6deg",
        12: "12deg"
      },
      space: ({ theme: e }) => ({
        ...e("spacing")
      }),
      spacing: {
        px: "1px",
        0: "0px",
        0.5: "0.125rem",
        1: "0.25rem",
        1.5: "0.375rem",
        2: "0.5rem",
        2.5: "0.625rem",
        3: "0.75rem",
        3.5: "0.875rem",
        4: "1rem",
        5: "1.25rem",
        6: "1.5rem",
        7: "1.75rem",
        8: "2rem",
        9: "2.25rem",
        10: "2.5rem",
        11: "2.75rem",
        12: "3rem",
        14: "3.5rem",
        16: "4rem",
        20: "5rem",
        24: "6rem",
        28: "7rem",
        32: "8rem",
        36: "9rem",
        40: "10rem",
        44: "11rem",
        48: "12rem",
        52: "13rem",
        56: "14rem",
        60: "15rem",
        64: "16rem",
        72: "18rem",
        80: "20rem",
        96: "24rem"
      },
      stroke: ({ theme: e }) => ({
        none: "none",
        ...e("colors")
      }),
      strokeWidth: {
        0: "0",
        1: "1",
        2: "2"
      },
      supports: {},
      data: {},
      textColor: ({ theme: e }) => e("colors"),
      textDecorationColor: ({ theme: e }) => e("colors"),
      textDecorationThickness: {
        auto: "auto",
        "from-font": "from-font",
        0: "0px",
        1: "1px",
        2: "2px",
        4: "4px",
        8: "8px"
      },
      textIndent: ({ theme: e }) => ({
        ...e("spacing")
      }),
      textOpacity: ({ theme: e }) => e("opacity"),
      textUnderlineOffset: {
        auto: "auto",
        0: "0px",
        1: "1px",
        2: "2px",
        4: "4px",
        8: "8px"
      },
      transformOrigin: {
        center: "center",
        top: "top",
        "top-right": "top right",
        right: "right",
        "bottom-right": "bottom right",
        bottom: "bottom",
        "bottom-left": "bottom left",
        left: "left",
        "top-left": "top left"
      },
      transitionDelay: {
        0: "0s",
        75: "75ms",
        100: "100ms",
        150: "150ms",
        200: "200ms",
        300: "300ms",
        500: "500ms",
        700: "700ms",
        1e3: "1000ms"
      },
      transitionDuration: {
        DEFAULT: "150ms",
        0: "0s",
        75: "75ms",
        100: "100ms",
        150: "150ms",
        200: "200ms",
        300: "300ms",
        500: "500ms",
        700: "700ms",
        1e3: "1000ms"
      },
      transitionProperty: {
        none: "none",
        all: "all",
        DEFAULT: "color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter",
        colors: "color, background-color, border-color, text-decoration-color, fill, stroke",
        opacity: "opacity",
        shadow: "box-shadow",
        transform: "transform"
      },
      transitionTimingFunction: {
        DEFAULT: "cubic-bezier(0.4, 0, 0.2, 1)",
        linear: "linear",
        in: "cubic-bezier(0.4, 0, 1, 1)",
        out: "cubic-bezier(0, 0, 0.2, 1)",
        "in-out": "cubic-bezier(0.4, 0, 0.2, 1)"
      },
      translate: ({ theme: e }) => ({
        ...e("spacing"),
        "1/2": "50%",
        "1/3": "33.333333%",
        "2/3": "66.666667%",
        "1/4": "25%",
        "2/4": "50%",
        "3/4": "75%",
        full: "100%"
      }),
      size: ({ theme: e }) => ({
        auto: "auto",
        ...e("spacing"),
        "1/2": "50%",
        "1/3": "33.333333%",
        "2/3": "66.666667%",
        "1/4": "25%",
        "2/4": "50%",
        "3/4": "75%",
        "1/5": "20%",
        "2/5": "40%",
        "3/5": "60%",
        "4/5": "80%",
        "1/6": "16.666667%",
        "2/6": "33.333333%",
        "3/6": "50%",
        "4/6": "66.666667%",
        "5/6": "83.333333%",
        "1/12": "8.333333%",
        "2/12": "16.666667%",
        "3/12": "25%",
        "4/12": "33.333333%",
        "5/12": "41.666667%",
        "6/12": "50%",
        "7/12": "58.333333%",
        "8/12": "66.666667%",
        "9/12": "75%",
        "10/12": "83.333333%",
        "11/12": "91.666667%",
        full: "100%",
        min: "min-content",
        max: "max-content",
        fit: "fit-content"
      }),
      width: ({ theme: e }) => ({
        auto: "auto",
        ...e("spacing"),
        "1/2": "50%",
        "1/3": "33.333333%",
        "2/3": "66.666667%",
        "1/4": "25%",
        "2/4": "50%",
        "3/4": "75%",
        "1/5": "20%",
        "2/5": "40%",
        "3/5": "60%",
        "4/5": "80%",
        "1/6": "16.666667%",
        "2/6": "33.333333%",
        "3/6": "50%",
        "4/6": "66.666667%",
        "5/6": "83.333333%",
        "1/12": "8.333333%",
        "2/12": "16.666667%",
        "3/12": "25%",
        "4/12": "33.333333%",
        "5/12": "41.666667%",
        "6/12": "50%",
        "7/12": "58.333333%",
        "8/12": "66.666667%",
        "9/12": "75%",
        "10/12": "83.333333%",
        "11/12": "91.666667%",
        full: "100%",
        screen: "100vw",
        svw: "100svw",
        lvw: "100lvw",
        dvw: "100dvw",
        min: "min-content",
        max: "max-content",
        fit: "fit-content"
      }),
      willChange: {
        auto: "auto",
        scroll: "scroll-position",
        contents: "contents",
        transform: "transform"
      },
      zIndex: {
        auto: "auto",
        0: "0",
        10: "10",
        20: "20",
        30: "30",
        40: "40",
        50: "50"
      }
    },
    plugins: []
  }), ut;
}
var Ln;
function So() {
  return Ln || (Ln = 1, function(e) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), Object.defineProperty(e, "default", {
      enumerable: !0,
      get: function() {
        return a;
      }
    });
    const t = Eo(), n = /* @__PURE__ */ r(Co());
    function r(i) {
      return i && i.__esModule ? i : {
        default: i
      };
    }
    const a = (0, t.cloneDeep)(n.default.theme);
  }(ct)), ct;
}
var dt, jn;
function Oo() {
  if (jn) return dt;
  jn = 1;
  let e = So();
  return dt = (e.__esModule ? e : { default: e }).default, dt;
}
var To = Oo();
const Dn = /* @__PURE__ */ vr(To), zo = {
  theme: {
    fontFamily: {
      sans: ["proxima-nova", ...Dn.fontFamily.sans]
    },
    fontWeight: {
      normal: "400",
      semibold: "600",
      bold: "700"
    },
    fontSize: {
      ...Dn.fontSize,
      "2sm": ["0.8125rem", "1.25rem"],
      // 13px, 20px
      "2xs": ["0.6875rem", "1rem"],
      // 11px, 16px
      "3xs": ["0.625rem", "0.75rem"],
      // 10px, 12px
      "4xs": ["0.5625rem", "0.75rem"]
      // 9px, 12px
    },
    colors: Ao,
    spacing: {
      px: "1px",
      0: "0px",
      0.5: "0.125rem",
      1: "0.25rem",
      1.5: "0.375rem",
      2: "0.5rem",
      2.5: "0.625rem",
      3: "0.75rem",
      3.5: "0.875rem",
      4: "1rem",
      5: "1.25rem",
      6: "1.5rem",
      7: "1.75rem",
      8: "2rem",
      9: "2.25rem",
      10: "2.5rem",
      11: "2.75rem",
      12: "3rem",
      14: "3.5rem",
      16: "4rem",
      20: "5rem",
      24: "6rem",
      28: "7rem",
      32: "8rem",
      36: "9rem",
      40: "10rem",
      44: "11rem",
      48: "12rem",
      52: "13rem",
      56: "14rem",
      60: "15rem",
      64: "16rem",
      72: "18rem",
      80: "20rem",
      96: "24rem"
    },
    extend: {
      // eslint-disable-next-line @typescript-eslint/unbound-method
      width: ({ breakpoints: e, theme: t }) => ({
        ...e(t("screens"))
      })
    }
  }
}, Lo = {
  arrowParens: "always",
  bracketSpacing: !0,
  htmlWhitespaceSensitivity: "css",
  insertPragma: !1,
  bracketSameLine: !1,
  jsxSingleQuote: !1,
  printWidth: 80,
  proseWrap: "preserve",
  quoteProps: "as-needed",
  requirePragma: !1,
  semi: !0,
  singleQuote: !0,
  tabWidth: 2,
  trailingComma: "es5",
  useTabs: !1,
  tailwindFunctions: ["clsx", "cx"],
  plugins: ["prettier-plugin-tailwindcss"]
};
export {
  _o as Alert,
  No as AlertList,
  Io as BigAlert,
  po as Button,
  Ht as Link,
  Fo as NavBar,
  Ro as Offset,
  lt as Stack,
  Mo as StyledLink,
  Ao as colors,
  Lo as prettierConfig,
  zo as tailwindPreset
};
